import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, OnChanges, OnInit, ViewChild } from '@angular/core';
import * as echarts from 'echarts';
import { EstacaoService } from 'src/services/estacao.service';
import { VariavelService } from 'src/services/variavel.service';
import * as moment from 'moment';
import { forkJoin } from 'rxjs';
import { ActivatedRoute } from '@angular/router';
import { EstacaoGrupoService } from 'src/services/estacao-grupos.service';
import { PessoaService } from 'src/services/pessoa.service';
import { SensorService } from 'src/services/sensor.service';
import { IntegracaoService } from 'src/services/integracao.service';
import { ColetaService } from 'src/services/coleta.service';
import { jsPDF } from 'jspdf';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { MessageService } from 'primeng/api';
import { VariavelComponent } from '../CADASTRO/variavel/variavel.component';
import { ResumoEventoDiaService } from 'src/services/resumo-evento.service';

@Component({
    selector: 'app-dashboard',
    templateUrl: './dashboard.component.html',
    styleUrls: ['./dashboard.component.scss'],
    standalone: false
})
export class DashboardComponent implements OnInit, AfterViewInit, OnChanges {
  rangeDate: any[] = [];
  value: any[] = [];
  tipo_variavel: any[] = [];
  dropDownEstacao: any[] = [];
  estacao_id: any
  jsonData: any[] = [];
  load: boolean = false

  dadosVariavel: any[] = [];
  columnsVariavel: any[] = [];
  descricao_estacao: any;
  @ViewChild('canvasChart', { static: true }) canvasChart: ElementRef<HTMLDivElement>;
  chartCanvas: echarts.ECharts;
  exibirFiltroAvancado: boolean = false
  modalNovoGrupo: boolean = false
  dados_nao_encontrados: boolean = false
  dropDownGrupos: any[] = [];
  dropDownSensores: any[] = [];
  dropDownClientes: any[] = [];
  clientesFiltrados: any[] = [];
  grupo: any
  sensor: any
  cliente: any

  estacaoColetas: any[] = [];
  estacaoConfiguracoesEvento: any[] = [];
  /** Casas decimais para vazão (estacao.casas_decimais_vazao); usado no gráfico e na tabela quando tiver vazão. */
  estacaoCasasDecimaisVazao: number | null = null;
  intervaloOperacao: number | null = null;
  exibirVazao: boolean = false;

  plu_filtro: any
  flu_filtro: any
  integrador_filtro: any[] = []
  coletor_filtro: any[] = []
  dropDownIntegradores: any[] = []
  dropDownColetores: any[] = []

  @ViewChild('range') rangeCalendar: any;
  tipoVisualizacao: 'grafico' | 'tabela' = 'tabela'; // Padrão: tabela
  dataFromQuery: string | null = null;
  dataInicialFromQuery: string | null = null;
  dataFinalFromQuery: string | null = null;
  user: any = JSON.parse(localStorage.getItem('user') ?? '{}');

  
  modalPercentual: boolean = false;
  modalTitulo: string = '';
  dadosPercentual: any[] = [];
  resumoPercentual: any = null;
  chartSelecionado: any = null;
  mensagemEstacaoNaoSelecionada: boolean = false;
  clienteRelatorio: string = '';
  horaLeituraRelatorio: string = '';
  pluRelatorio: string = '';
  fluRelatorio: string = '';
  serialTransmissorRelatorio: string = '';
  emMonitoramentoRelatorio: boolean = false;
  modalSnirhSerieHistorica: boolean = false;
  loadingSnirhSerieHistorica: boolean = false;
  snirhSerieHistoricaTitulo: string = 'Série histórica SNIRH';
  snirhSerieHistoricaHtml: SafeHtml | null = null;

  @ViewChild('chartsContainer') chartsContainer: ElementRef;
  @ViewChild(VariavelComponent) variavelComponent?: VariavelComponent;
  device = localStorage.getItem('device');

  constructor(
    protected _variavelService: VariavelService,
    protected _estacaoService: EstacaoService,
    protected _estacaoGrupoService: EstacaoGrupoService,
    protected _pessoaService: PessoaService,
    protected _sensorService: SensorService,
    protected _integracaoService: IntegracaoService,
    protected _coletorService: ColetaService,
    private route: ActivatedRoute,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private messageService: MessageService,
    private resumoEventoDiaService: ResumoEventoDiaService,
  ) { }

  get isUsuarioInterno(): boolean {
    return this.user?.usuario_interno === true;
  }

  get isUsuarioExterno(): boolean {
    return !this.isUsuarioInterno;
  }

  private get clienteIdsDoUsuario(): number[] {
    const ids = new Set<number>();
    const empresaId = Number(this.user?.empresa_id);
    if (Number.isFinite(empresaId) && empresaId > 0) {
      ids.add(empresaId);
    }

    const empresas = Array.isArray(this.user?.empresas) ? this.user.empresas : [];
    for (const item of empresas) {
      const id = Number(item?.empresa_id ?? item?.empresa?.id);
      if (Number.isFinite(id) && id > 0) {
        ids.add(id);
      }
    }

    return [...ids];
  }

  private pertenceAosClientesDoUsuario(clienteId: any): boolean {
    const ids = this.clienteIdsDoUsuario;
    if (!ids.length) {
      return false;
    }
    return ids.includes(Number(clienteId));
  }

  private filtrarGruposDoUsuarioExterno(grupos: any[]): any[] {
    if (!this.isUsuarioExterno) {
      return grupos;
    }

    const ids = this.clienteIdsDoUsuario;
    if (!ids.length) {
      return grupos;
    }

    return grupos.filter(grupo => {
      if (this.pertenceAosClientesDoUsuario(grupo?.empresa_id)) {
        return true;
      }
      return (grupo?.estacoes || []).some((estacao: any) =>
        this.pertenceAosClientesDoUsuario(estacao?.cliente_id ?? estacao?.cliente?.id)
      );
    });
  }

  private filtrarSensoresDoUsuarioExterno(sensores: any[]): any[] {
    if (!this.isUsuarioExterno) {
      return sensores;
    }

    const ids = this.clienteIdsDoUsuario;
    if (!ids.length) {
      return sensores;
    }

    return sensores.filter(sensor =>
      this.pertenceAosClientesDoUsuario(
        sensor?.estacao?.cliente_id ?? sensor?.estacao?.cliente?.id
      )
    );
  }

  exportarTabelaExcel(): void {
    this.variavelComponent?.exportExcel();
  }

  exportarTabelaPdf(): void {
    this.variavelComponent?.exportPdf();
  }

  /**
   * Formata um valor numérico baseado no número de casas decimais configurado para a variável
   * @param value Valor numérico a ser formatado
   * @param tipoVariavelId ID do tipo de variável
   * @returns Valor formatado como string
   */
  /** ID do tipo de variável VAZÃO (usado para aplicar estacao.casas_decimais_vazao). */
  private static readonly TIPO_VARIAVEL_VAZAO = 4;
  /** ID do tipo de variável Chuva. */
  private static readonly TIPO_VARIAVEL_CHUVA = 3;
  /** ID do tipo de variável Chuva acumulada. */
  private static readonly TIPO_VARIAVEL_CHUVA_ACUMULADA = 5;
  /** ID do tipo de variável Bateria. */
  private static readonly TIPO_VARIAVEL_BATERIA = 1;
  /** ID do tipo de variável Nível. */
  private static readonly TIPO_VARIAVEL_NIVEL = 2;
  /** ID do tipo de variável Radar. */
  private static readonly TIPO_VARIAVEL_RADAR = 7;

  formatarValor(value: number | string, tipoVariavelId: number): string {
    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numValue)) return value.toString();

    // Para vazão, utilizar estacao.casas_decimais_vazao quando disponível
    let casasDecimais: number | null | undefined;
    if (tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_VAZAO) {
      casasDecimais = this.estacaoCasasDecimaisVazao;
    }
    if (casasDecimais === null || casasDecimais === undefined) {
      const estacaoColetaVariavel = this.estacaoColetas.find(x => x.tipo_variavel_id == tipoVariavelId);
      casasDecimais = estacaoColetaVariavel?.casas_decimais;
    }

    // Se casas_decimais for null ou undefined, mantém formatação padrão (1 casa decimal)
    if (casasDecimais === null || casasDecimais === undefined) {
      return numValue.toFixed(1).replace('.', ',');
    }

    // Usa o número de casas decimais configurado
    return numValue.toFixed(casasDecimais).replace('.', ',');
  }

  ngOnInit(): void {
    // Lê os parâmetros de rota e query parameters primeiro
    const dataParametro = this.route.snapshot.paramMap.get('data');
    const dataQuery = this.route.snapshot.queryParamMap.get('data');
    const dataInicialQuery = this.route.snapshot.queryParamMap.get('dataInicial');
    const dataFinalQuery = this.route.snapshot.queryParamMap.get('dataFinal');
    
    // Define o tipo de visualização baseado no parâmetro de rota
    this.definirTipoVisualizacao(dataParametro);
    
    // Armazena as datas dos query parameters se existirem
    if (dataQuery) {
      this.dataFromQuery = dataQuery;
    }
    if (dataInicialQuery) {
      this.dataInicialFromQuery = dataInicialQuery;
    }
    if (dataFinalQuery) {
      this.dataFinalFromQuery = dataFinalQuery;
    }

    this.tipo_variavel = []
    this._variavelService.getType().subscribe(json => {
      json.map(item => {
        this.tipo_variavel.push({
          label: item.tipo_variavel, value: item.id
        })
      })
      // Garantir que Chuva (3) e Chuva acumulada (5) existam no dropdown para labels e request
      const ids = this.tipo_variavel.map((t: any) => t.value);
      if (!ids.includes(DashboardComponent.TIPO_VARIAVEL_CHUVA)) {
        this.tipo_variavel.push({ label: 'Chuva', value: DashboardComponent.TIPO_VARIAVEL_CHUVA });
      }
      if (!ids.includes(DashboardComponent.TIPO_VARIAVEL_CHUVA_ACUMULADA)) {
        this.tipo_variavel.push({ label: 'Chuva acumulada', value: DashboardComponent.TIPO_VARIAVEL_CHUVA_ACUMULADA });
      }
    })

    // Inicializa rangeDate com padrão, mas será sobrescrito se houver data nos parâmetros
    this.rangeDate = this.getDefaultDateRange();
    
    this.listEstacoes()
    this.listGrupos()
    this.listSensores()
    this.listClientes()
    this.listIntegrador()
    this.listColetor()
    
    // Observa mudanças nos parâmetros
    this.route.paramMap.subscribe(params => {
      const newDataParametro = params.get('data');
      this.definirTipoVisualizacao(newDataParametro);
      this.cdr.detectChanges();
    });

    this.route.queryParamMap.subscribe(queryParams => {
      const newDataQuery = queryParams.get('data');
      const newDataInicial = queryParams.get('dataInicial');
      const newDataFinal = queryParams.get('dataFinal');
      
      if (newDataQuery) {
        this.dataFromQuery = newDataQuery;
      }
      if (newDataInicial) {
        this.dataInicialFromQuery = newDataInicial;
      }
      if (newDataFinal) {
        this.dataFinalFromQuery = newDataFinal;
      }
      
      // Se já tiver as estações carregadas, aplica o filtro novamente
      if (this.dropDownEstacao.length > 0 && this.estacao_id) {
        if (newDataInicial && newDataFinal) {
          this.aplicarFiltroComPeriodo();
        } else if (newDataQuery) {
          this.aplicarFiltroComData();
        }
      }
    });
  }

  


  abrirModalPercentual(chart: any): void {
    this.chartSelecionado = chart;
    this.modalTitulo = `Percentuais - ${chart.tipo_variavel.tipo_variavel}`;
    this.calcularPercentuais(chart);
    this.modalPercentual = true;
  }

  calcularPercentuais(chart: any): void {
    this.dadosPercentual = [];
    this.resumoPercentual = null;
    
    if (!chart || !chart.dados || chart.dados.length === 0) return;
    
    const tipoVariavelId = chart?.tipo_variavel?.id;
    const valores = chart.dados.map((d: any) => parseFloat(d.valor)).filter(v => !isNaN(v));
    
    if (valores.length === 0) return;
    
    // Calcular média dos dados
    const media = valores.reduce((a, b) => a + b, 0) / valores.length;
    
    if (tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_BATERIA) {
        this.calcularPercentuaisBateria(valores, media);
    } else if (tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_NIVEL) {
        this.calcularPercentuaisNivel(valores, media);
    }
    
    // Calcular resumo
    if (this.dadosPercentual.length > 0) {
        const percentuais = this.dadosPercentual.map(p => p.percentual);
        const variacaoTotal = percentuais.reduce((a, b) => a + b, 0) / percentuais.length;
        
        this.resumoPercentual = {
            media: media,
            variacaoTotal: variacaoTotal
        };
    }
  }

  private calcularPercentuaisBateria(valores: number[], media: number): void {
    const minCfg = this.getConfiguracaoEvento(1);
    const maxCfg = this.getConfiguracaoEvento(2);
    
    if (minCfg?.valor_parametro) {
        const referencia = this.parseConfigValue(minCfg.valor_parametro);
        if (referencia !== null) {
            const percentual = this.calcularPercentual(media, referencia);
            this.dadosPercentual.push({
                label: 'Em relação ao mínimo (bateria baixa)',
                valor: media,
                referencia: referencia,
                percentual: percentual,
                configuracao: minCfg
            });
        }
    }
    
    if (maxCfg?.valor_parametro) {
        const referencia = this.parseConfigValue(maxCfg.valor_parametro);
        if (referencia !== null) {
            const percentual = this.calcularPercentual(media, referencia);
            this.dadosPercentual.push({
                label: 'Em relação ao mínimo (baixa painel)',
                valor: media,
                referencia: referencia,
                percentual: percentual,
                configuracao: maxCfg
            });
        }
    }
  }

  private calcularPercentuaisNivel(valores: number[], media: number): void {
    const cfg = this.getConfiguracaoEvento(5);
    
    if (cfg?.valor_minimo) {
        const referencia = this.parseConfigValue(cfg.valor_minimo);
        if (referencia !== null) {
            const percentual = this.calcularPercentual(media, referencia);
            this.dadosPercentual.push({
                label: 'Em relação ao nível mínimo',
                valor: media,
                referencia: referencia,
                percentual: percentual,
                configuracao: cfg
            });
        }
    }
    
    if (cfg?.valor_maximo) {
        const referencia = this.parseConfigValue(cfg.valor_maximo);
        if (referencia !== null) {
            const percentual = this.calcularPercentual(media, referencia);
            this.dadosPercentual.push({
                label: 'Em relação ao nível máximo',
                valor: media,
                referencia: referencia,
                percentual: percentual,
                configuracao: cfg
            });
        }
    }
  }

  private calcularPercentual(valor: number, referencia: number): number {
    if (referencia === 0) return 0;
    return ((valor - referencia) / referencia) * 100;
  }

  
  private aplicarFiltroComData(): void {
    if (this.dataFromQuery) {
      const dataFormatada = `${this.dataFromQuery}T12:00:00`;
      this.rangeDate = [
        new Date(dataFormatada),
        new Date(dataFormatada)
      ];
      // Força a atualização do calendário se existir
      if (this.rangeCalendar) {
        this.rangeCalendar.updateModel(this.rangeDate);
      }
      this.filtrar();
    }
  }
  
  private aplicarFiltroComPeriodo(): void {
    if (this.dataInicialFromQuery && this.dataFinalFromQuery) {
      const dataInicialFormatada = `${this.dataInicialFromQuery}T00:00:00`;
      const dataFinalFormatada = `${this.dataFinalFromQuery}T23:59:59`;
      this.rangeDate = [
        new Date(dataInicialFormatada),
        new Date(dataFinalFormatada)
      ];
      // Força a atualização do calendário se existir
      if (this.rangeCalendar) {
        this.rangeCalendar.updateModel(this.rangeDate);
      }
      this.filtrar();
    }
  }

  gerarPDF(): void {
    if (!this.dadosVariavel || this.dadosVariavel.length === 0) {
      console.warn('Nenhum dado disponível para exportar.');
      return;
    }

    if (!this.exibirGraficos) {
      this.gerarPDFTabela();
      return;
    }

    const pdf = new jsPDF('l', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 10;
    const chartWidth = pageWidth - (margin * 2);
    const chartHeight = (pageHeight - (margin * 2)) * 0.8;

    const header = this.getReportHeader();

    let addedCharts = 0;
    this.jsonData.forEach((grafico, index) => {
      const chartElement = document.getElementById(`chart-${index}`);
      if (!chartElement) {
        console.warn(`Elemento do gráfico ${index} não encontrado`);
        return;
      }

      const echartsInstance = echarts.getInstanceByDom(chartElement);
      if (!echartsInstance) {
        console.warn(`Instância ECharts do gráfico ${index} não encontrada`);
        return;
      }

      if (addedCharts > 0) pdf.addPage();
      addedCharts++;

      const tituloPagina = grafico?.tipo_variavel?.tipo_variavel || 'Gráfico';
      let textY = margin + 8;

      pdf.setFontSize(16);
      pdf.setFont('helvetica', 'bold');
      pdf.text(tituloPagina, pageWidth / 2, textY, { align: 'center' });

      pdf.setFontSize(9);
      pdf.setFont('helvetica', 'normal');
      header.forEach((line) => {
        textY += 7;
        pdf.text(line, pageWidth / 2, textY, { align: 'center' });
      });

      const imgData = echartsInstance.getDataURL({ type: 'png', pixelRatio: 2, backgroundColor: '#ffffff' });
      const yPos = Math.max(textY + 12, margin + 38);
      pdf.addImage(imgData, 'PNG', margin, yPos, chartWidth, chartHeight);

      pdf.setFontSize(10);
      pdf.setFont('helvetica', 'normal');
      const rodape = `Página ${addedCharts} de ${this.jsonData.length} — Gerado em ${moment().format('DD/MM/YYYY HH:mm')}`;
      pdf.text(rodape, pageWidth / 2, pageHeight - margin, { align: 'center' });
    });

    this.adicionarTabelaAoPDF(pdf, null).then(() => {
      pdf.save(`relatorio-graficos-${moment().format('YYYYMMDD-HHmmss')}.pdf`);
    });
  }

  gerarPDFA4Vertical(): void {
    if (!this.dadosVariavel || this.dadosVariavel.length === 0) {
      console.warn('Nenhum dado disponível para exportar.');
      return;
    }

    if (!this.exibirGraficos) {
      this.gerarPDFTabela();
      return;
    }

    const graficosVisiveis = this.jsonData;
    const pdf = new jsPDF('p', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const pageHeight = pdf.internal.pageSize.getHeight();
    const margin = 10;
    const chartsPerPage = 3;

    const header = this.getReportHeader();

    const totalPaginas = Math.ceil(graficosVisiveis.length / chartsPerPage) + 1; // +1 for table page
    const labelAlturaMm = 6;

    const executar = async (): Promise<void> => {
      let indiceGlobal = 0;
      let numPagina = 0;

      while (indiceGlobal < graficosVisiveis.length) {
        if (numPagina > 0) {
          pdf.addPage();
        }

        const fimBloco = Math.min(indiceGlobal + chartsPerPage, graficosVisiveis.length);
        const capturas: { imgData: string; nomeVariavel: string; aspect: number }[] = [];

        for (let i = indiceGlobal; i < fimBloco; i++) {
          const chartElement = document.getElementById(`chart-${i}`);
          const nomeVariavel =
            graficosVisiveis[i]?.tipo_variavel?.tipo_variavel || `Gráfico ${i + 1}`;

          if (!chartElement) {
            console.warn(`Elemento do gráfico ${i} não encontrado`);
            continue;
          }

          const echartsInstance = echarts.getInstanceByDom(chartElement);
          if (!echartsInstance) {
            console.warn(`Instância ECharts do gráfico ${i} não encontrada`);
            continue;
          }

          const imgData = echartsInstance.getDataURL({ type: 'png', pixelRatio: 2, backgroundColor: '#ffffff' });
          const aspect = (chartElement.offsetWidth || 4) / (chartElement.offsetHeight || 3);
          capturas.push({ imgData, nomeVariavel, aspect });
        }

        let y = margin;
        pdf.setFontSize(12);
        pdf.setFont('helvetica', 'bold');
        pdf.text(this.descricao_estacao ? `Estação: ${this.descricao_estacao}` : 'Estação: —', pageWidth / 2, y + 5, { align: 'center' });
        y += 8;
        pdf.setFontSize(8);
        pdf.setFont('helvetica', 'normal');
        header.slice(1).forEach((line) => {
          pdf.text(line, pageWidth / 2, y + 3, { align: 'center' });
          y += 5;
        });
        y += 3;

        const areaUtilAltura = pageHeight - y - margin - 7;
        const n = Math.max(capturas.length, 1);
        const slotAltura = areaUtilAltura / n;

        for (let s = 0; s < capturas.length; s++) {
          const { imgData, nomeVariavel, aspect } = capturas[s];
          const slotTopo = y + s * slotAltura;

          pdf.setFontSize(9);
          pdf.setFont('helvetica', 'bold');
          pdf.text(nomeVariavel, margin, slotTopo + 4);

          const maxW = pageWidth - margin * 2;
          const maxH = Math.max(8, slotAltura - labelAlturaMm - 2);
          let imgW = maxW;
          let imgH = imgW / aspect;
          if (imgH > maxH) {
            imgH = maxH;
            imgW = imgH * aspect;
          }
          const xImg = margin + (maxW - imgW) / 2;
          const yImg = slotTopo + labelAlturaMm;
          pdf.addImage(imgData, 'PNG', xImg, yImg, imgW, imgH);
        }

        pdf.setFontSize(8);
        pdf.setFont('helvetica', 'normal');
        pdf.text(
          `Página ${numPagina + 1} de ${totalPaginas} — Gerado em ${moment().format('DD/MM/YYYY HH:mm')}`,
          pageWidth / 2,
          pageHeight - margin,
          { align: 'center' }
        );

        indiceGlobal = fimBloco;
        numPagina++;
      }

      await this.adicionarTabelaAoPDF(pdf, null);
      pdf.save(`relatorio-graficos-a4-vertical-${moment().format('YYYYMMDD-HHmmss')}.pdf`);
    };

    void executar();
  }

  private gerarPDFTabela(): void {
    if (!this.dadosVariavel || this.dadosVariavel.length === 0) {
      console.warn('Nenhum dado de tabela disponível para exportar.');
      return;
    }

    const pdf = new jsPDF('l', 'mm', 'a4');
    const pageWidth = pdf.internal.pageSize.getWidth();
    const margin = 10;

    const header = this.getReportHeader();

    let y = margin + 5;
    pdf.setFontSize(14);
    pdf.setFont('helvetica', 'bold');
    pdf.text(header[0], pageWidth / 2, y, { align: 'center' });
    y += 7;
    pdf.setFontSize(8);
    pdf.setFont('helvetica', 'normal');
    header.slice(1).forEach((line) => {
      pdf.text(line, pageWidth / 2, y, { align: 'center' });
      y += 5;
    });
    y += 3;

    this.adicionarTabelaAoPDF(pdf, y).then(() => {
      pdf.save(`relatorio-tabela-${moment().format('YYYYMMDD-HHmmss')}.pdf`);
    });
  }

  private adicionarTabelaAoPDF(pdf: jsPDF, startY: number | null): Promise<void> {
    return import('jspdf-autotable').then((mod) => {
      if (!this.dadosVariavel || this.dadosVariavel.length === 0) return;

      const cols = (this.columnsVariavel || []).filter((c: any) => c.field !== 'timestamp');
      const head = [cols.map((c: any) => c.header)];
      const body = this.dadosVariavel.map((row: any) => cols.map((c: any) => row[c.field] ?? ''));

      if (startY === null) {
        pdf.addPage();
      }

      const autoTable = mod.default ?? (mod as any);
      autoTable(pdf, {
        head,
        body,
        startY: startY ?? undefined,
        styles: { fontSize: 7, overflow: 'linebreak', cellPadding: 2 },
        headStyles: { fillColor: [66, 139, 202], fontStyle: 'bold' },
      });
    });
  }

  private getDefaultDateRange(): Date[] {
    const hoje = new Date();
    const trintaDiasAtras = new Date();
    trintaDiasAtras.setDate(hoje.getDate() - 30);
    
    trintaDiasAtras.setHours(0, 0, 0, 0);
    hoje.setHours(23, 59, 59, 999);
    
    return [trintaDiasAtras, hoje];
  }

  private definirTipoVisualizacao(dataParametro: string | null): void {
    const tipoAnterior = this.tipoVisualizacao;
    let novoTipo: 'grafico' | 'tabela' = 'tabela';
    
    if (dataParametro && dataParametro.toLowerCase() === 'grafico') {
      novoTipo = 'grafico';
    } else if (dataParametro && dataParametro.toLowerCase() === 'tabela') {
      novoTipo = 'tabela';
    }
    
    // Se o tipo mudou, limpa os dados
    if (tipoAnterior !== novoTipo) {
      this.limparDados();
    }
    
    this.tipoVisualizacao = novoTipo;
  }

  private limparDados(): void {
    this.jsonData = [];
    this.value = [];
    this.dadosVariavel = [];
    this.columnsVariavel = [];
    this.load = false;
    this.dados_nao_encontrados = false;
    this.limparCabecalhoRelatorio();
    
    // Limpar gráficos se existirem
    if (this.chartCanvas) {
      this.chartCanvas.dispose();
      this.chartCanvas = null;
    }
    
    // Limpar container de gráficos
    if (this.chartsContainer && this.chartsContainer.nativeElement) {
      const container = this.chartsContainer.nativeElement;
      while (container.firstChild) {
        container.removeChild(container.firstChild);
      }
    }
  }

  get exibirGraficos(): boolean {
    return this.tipoVisualizacao === 'grafico';
  }

  get exibirTabela(): boolean {
    return this.tipoVisualizacao === 'tabela';
  }

  listIntegrador() {
    this._integracaoService.index().subscribe(json => {
      this.dropDownIntegradores = json
    })
  }

  listColetor() {
    this._coletorService.index().subscribe(json => {
      this.dropDownColetores = json
    })
  }

  listClientes() {
    this.dropDownClientes = []
    const request$ = this.isUsuarioExterno
      ? this._pessoaService.listEmpresas()
      : this._pessoaService.index();
    request$.subscribe(json => {
      let ret = json.filter(x => x.ativo == true)
      if (this.isUsuarioExterno) {
        const ids = this.clienteIdsDoUsuario;
        if (ids.length) {
          ret = ret.filter(item => this.pertenceAosClientesDoUsuario(item.id));
        }
      }
      ret.map(item => {
        this.dropDownClientes.push({
          label: item.nome, value: item.id
        })

      })
    })
  }

  listGrupos() {
    this.dropDownGrupos = []
    this._estacaoGrupoService.index().subscribe(json => {
      const grupos = this.filtrarGruposDoUsuarioExterno(json || []);
      grupos.map(item => {
        this.dropDownGrupos.push({
          label: item.nome, value: item.id
        })

      })
    })
  }

  filtrarClientes(event) {
    let query = event.query;
    this._pessoaService.autocomplete(query).subscribe((json) => {
      let clientes = [];
      json.map((item) => {
        clientes.push({
          value: item.value,
          label: item.label,
        });
        this.clientesFiltrados = clientes;
      });
    });
  }

  listSensores() {
    this.dropDownSensores = []
    this._sensorService.index().subscribe(json => {
      const sensores = this.filtrarSensoresDoUsuarioExterno(json || []);
      sensores.map(item => {

        this.dropDownSensores.push({
          value: item.id, label: item.descricao,
        })


      })
    })
  }

  ngAfterViewInit(): void {
    this.initializeCharts();
  }

  ngOnChanges(): void {
    this.initializeCharts();
  }

  // listTipos(){
  //   this.tipo_variavel = []
  //   this._variavelService.getType().subscribe(json => {
  //     json.map(item => {
  //       this.tipo_variavel.push({
  //         label: item.tipo_variavel, value: item.id
  //       })
  //     })
  //   })
  // }
  private buildEstacaoDropdownOption(estacao: any): { label: string; value: any; cliente: string; nomeEstacao: string; flu: string; plu: string; id: string } {
    const clienteNome = estacao?.cliente?.nome?.trim() || '';
    let nomeEstacao = (estacao?.descricao || '').trim();

    if (clienteNome && nomeEstacao.endsWith(` - ${clienteNome}`)) {
      nomeEstacao = nomeEstacao.slice(0, nomeEstacao.length - clienteNome.length - 3).trim();
    }

    const flu = estacao?.flu?.toString().trim() || '';
    const plu = estacao?.plu?.toString().trim() || '';
    const id = estacao?.id != null ? String(estacao.id) : '';

    const partes: string[] = [];
    if (id) {
      partes.push(id);
    }
    if (nomeEstacao) {
      partes.push(nomeEstacao);
    }
    if (clienteNome) {
      partes.push(clienteNome);
    }

    const codigos: string[] = [];
    if (plu) {
      codigos.push(plu);
    }
    if (flu) {
      codigos.push(flu);
    }

    let label = partes.join(' - ');
    if (codigos.length) {
      label += ` (${codigos.join(' ')})`;
    }

    if (!label) {
      label = nomeEstacao || id;
    }

    return {
      label,
      value: estacao.id,
      cliente: clienteNome,
      nomeEstacao,
      flu,
      plu,
      id,
    };
  }

  listEstacoes() {
    this.dropDownEstacao = []
    this.dropDownEstacao.push({
      label: 'Selecione', value: 'null', cliente: '', nomeEstacao: '', flu: '', plu: '', id: ''
    })
    this._estacaoService.lookup().subscribe(json => {
      json.map(item => {
        this.dropDownEstacao.push(this.buildEstacaoDropdownOption(item))
      })
      setTimeout(() => {
        const idParam = this.route.snapshot.paramMap.get('id');
        if (idParam && idParam !== 'null') {
          this.estacao_id = parseInt(idParam);
          
          // Verifica primeiro se há período (dataInicial e dataFinal) nos query parameters (vindo do mapa)
          if (this.dataInicialFromQuery && this.dataFinalFromQuery) {
            const dataInicialFormatada = `${this.dataInicialFromQuery}T00:00:00`;
            const dataFinalFormatada = `${this.dataFinalFromQuery}T23:59:59`;
            this.rangeDate = [
              new Date(dataInicialFormatada),
              new Date(dataFinalFormatada)
            ];
            // Atualiza o calendário se existir
            if (this.rangeCalendar) {
              this.rangeCalendar.updateModel(this.rangeDate);
            }
            console.log('Período ajustado:', this.rangeDate, 'Estação:', this.estacao_id);
          } 
          // Se não tiver período, verifica se há data única no query parameter
          else {
            const dataParametro = this.dataFromQuery || this.route.snapshot.paramMap.get('data');
            if (dataParametro && dataParametro !== 'tabela' && dataParametro !== 'grafico') {
              const dataFormatada = `${dataParametro}T12:00:00`;
              this.rangeDate = [
                new Date(dataFormatada),
                new Date(dataFormatada)
              ];
              // Atualiza o calendário se existir
              if (this.rangeCalendar) {
                this.rangeCalendar.updateModel(this.rangeDate);
              }
              console.log('Data ajustada:', this.rangeDate, 'Estação:', this.estacao_id);
            }
          }
          
          // Aplica o filtro automaticamente após um pequeno delay para garantir que tudo está carregado
          setTimeout(() => {
            console.log('Aplicando filtro automaticamente...', {
              estacao_id: this.estacao_id,
              rangeDate: this.rangeDate,
              tipoVisualizacao: this.tipoVisualizacao
            });
            this.filtrar();
          }, 100);
        }
      }, 300);
    })
  }

  toggleFiltroAvancado(): void {
    this.exibirFiltroAvancado = !this.exibirFiltroAvancado;
  }

  filtrar() {
    console.log('range', this.rangeDate)
    
    // Validação: verifica se a estação foi selecionada
    if (!this.estacao_id || this.estacao_id === 'null' || this.estacao_id === null) {
      this.mensagemEstacaoNaoSelecionada = true;
      this.dados_nao_encontrados = false;
      // Limpa os dados quando não há estação selecionada
      this.dadosVariavel = [];
      this.columnsVariavel = [];
      this.jsonData = [];
      this.descricao_estacao = '';
      this.estacaoColetas = [];
      this.estacaoConfiguracoesEvento = [];
      this.estacaoCasasDecimaisVazao = null;
      this.limparCabecalhoRelatorio();
      return;
    }
    
    // Se chegou aqui, a estação foi selecionada, então esconde a mensagem
    this.mensagemEstacaoNaoSelecionada = false;
    
    // Inicializa/limpa os dados antes de cada filtro
    this.dadosVariavel = [];
    this.columnsVariavel = [];
    this.descricao_estacao = '';
    this.estacaoColetas = [];
    this.estacaoConfiguracoesEvento = [];
    this.estacaoCasasDecimaisVazao = null;
    this.intervaloOperacao = null;
    this.exibirVazao = false;
    this.limparCabecalhoRelatorio();

    let grupos: any = []
    let clientes: any = []
    let sensores: any = []
    let integradores: any = []
    let coletores: any = []

    if (this.grupo) {
      this.grupo.map(item => {
        grupos.push(item.value)
      })
    }
    if (this.cliente) {
      this.cliente.map(item => {
        clientes.push(item.value)
      })
    }
    if (this.sensor) {
      this.sensor.map(item => {
        sensores.push(item.value)
      })
    }
    if (this.integrador_filtro) {
      this.integrador_filtro.map(item => {
        integradores.push(item.id)
      })
    }
    if (this.coletor_filtro) {
      this.coletor_filtro.map(item => {
        coletores.push(item.id)
      })
    }

    let tipo_variavel: any[] = this.tipo_variavel.map(item => item.value);
    // Garantir que Chuva (3) e Chuva acumulada (5) sejam sempre solicitados, para estações que tenham em estacao_coletas com visualizar
    if (!tipo_variavel.includes(DashboardComponent.TIPO_VARIAVEL_CHUVA)) {
      tipo_variavel.push(DashboardComponent.TIPO_VARIAVEL_CHUVA);
    }
    if (!tipo_variavel.includes(DashboardComponent.TIPO_VARIAVEL_CHUVA_ACUMULADA)) {
      tipo_variavel.push(DashboardComponent.TIPO_VARIAVEL_CHUVA_ACUMULADA);
    }

    let params = {
      data_inicial: moment(this.rangeDate[0]).format('YYYY-MM-DDT00:00:00'),
      data_final: moment(this.rangeDate[1]).format('YYYY-MM-DDT23:59:59'),
      estacao_id: this.estacao_id,
      tipo_variavel_id: tipo_variavel,
      grupoList: grupos,
      clientesList: clientes,
      sensorList: sensores,
      plu: this.plu_filtro,
      flu: this.flu_filtro,
      integradorList: integradores,
      coletorList: coletores,
    };

    if (params.estacao_id == 'null') {
      delete params.estacao_id
    }


    forkJoin([
      this._variavelService.group(params),
      this._variavelService.filter(params),
    ]).subscribe((json: any) => {
      console.log(json)
      if (json[0].length > 0) {
        this.estacaoColetas = json[0][0].estacao?.estacao_coletas || [];
        this.estacaoConfiguracoesEvento = json[0][0].estacao?.configuracoes_evento || [];
        // Carrega exibir_vazao e casas_decimais_vazao da estação (se disponível em json[0])
        if (json[0][0].estacao?.exibir_vazao !== undefined) {
          this.exibirVazao = json[0][0].estacao.exibir_vazao == true;
        }
        const casasVazao = json[0][0].estacao?.casas_decimais_vazao ?? json[0][0].estacao?.casasDecimaisVazao;
        if (casasVazao !== undefined && casasVazao !== null) {
          this.estacaoCasasDecimaisVazao = Number(casasVazao);
        } else {
          this.estacaoCasasDecimaisVazao = null;
        }
        
        // Filtra apenas variáveis com visible == true e processa os dados
        this.jsonData = json[0][0].tipos_variaveis?.map((variavel: any) => {
          const dados = variavel.dados || [];
          const dadosProcessados = dados.map((dado: any) => {
            // A API retorna a data/hora como horário de Brasília, mas marcada como UTC (com Z)
            const dataHoraStr = dado.data_hora_dado.replace('Z', '');
            const dataHoraBrasilia = moment(dataHoraStr).utcOffset(-180, true);
            const valorConsolidado = this.consolidarValorChuvaAcumuladaCalculada(
              dado.valor,
              variavel.tipo_variavel.id
            );

            return {
              ...dado,
              valor: valorConsolidado,
              data_hora_dado: dataHoraBrasilia.format('DD/MM/YYYY HH:mm:ss'),
              timestamp: dataHoraBrasilia.valueOf(),
              valor_original: valorConsolidado
            };
          });
          
          return {
            ...variavel,
            dados: dadosProcessados
          };
        }).filter((variavel) => {
          const estacaoColetaVariavel = this.estacaoColetas.find(x => x.tipo_variavel_id == variavel.tipo_variavel.id);
          return this.isVariavelVisivel(variavel.tipo_variavel.id, estacaoColetaVariavel);
        });
        // Incluir séries para tipos visíveis em estacao_coletas que a API não retornou (ex.: tipo 5 sem dados)
        this.adicionarSeriesVisiveisFaltantesJsonData();
        if (this.deveInverterChuvaChuvaAcumulada()) {
          this.inverterValoresChuvaChuvaAcumuladaJsonData();
        }
      }
      // Processa json[1] - pode ser um objeto único ou array
      const dadosGroupData = Array.isArray(json[1]) ? json[1][0] : json[1];
      
      if (dadosGroupData && dadosGroupData.estacao) {
        // Carrega estacao_coletas do objeto estacao
        if (this.estacaoColetas.length === 0 && dadosGroupData.estacao.estacao_coletas) {
          this.estacaoColetas = dadosGroupData.estacao.estacao_coletas;
        }
        if (this.estacaoConfiguracoesEvento.length === 0 && dadosGroupData.estacao.configuracoes_evento) {
          this.estacaoConfiguracoesEvento = dadosGroupData.estacao.configuracoes_evento;
        }
        // Carrega intervalo_operacao da estação
        if (dadosGroupData.estacao.intervalo_operacao !== undefined && dadosGroupData.estacao.intervalo_operacao !== null) {
          this.intervaloOperacao = dadosGroupData.estacao.intervalo_operacao;
        }
        // Carrega exibir_vazao e casas_decimais_vazao da estação
        if (dadosGroupData.estacao.exibir_vazao !== undefined) {
          this.exibirVazao = dadosGroupData.estacao.exibir_vazao == true;
        }
        const casasVazaoEstacao = dadosGroupData.estacao.casas_decimais_vazao ?? dadosGroupData.estacao.casasDecimaisVazao;
        if (casasVazaoEstacao !== undefined && casasVazaoEstacao !== null) {
          this.estacaoCasasDecimaisVazao = Number(casasVazaoEstacao);
        } else {
          this.estacaoCasasDecimaisVazao = null;
        }
        
        // Se houver intervalo_operacao, preenche os intervalos faltantes nos gráficos (igual à tabela)
        // Com dados: preenche intervalos; sem dados: cria intervalos vazios por variável visível
        if (this.intervaloOperacao && this.intervaloOperacao > 0) {
          if (this.jsonData.length > 0) {
            this.preencherIntervalosGraficos();
          } else {
            this.criarIntervalosVaziosGrafico(json[0]);
          }
        }
        
        // Preenche `dadosVariavel` com os dados processados
        if (dadosGroupData.data_hora_dados && Array.isArray(dadosGroupData.data_hora_dados)) {
          dadosGroupData.data_hora_dados.forEach(dataItem => {
            // A API retorna a data/hora como horário de Brasília, mas marcada como UTC (com Z)
            // Exemplo: "2026-01-14T04:00:00.000000Z" representa 04:00 de Brasília, não 04:00 UTC
            // Precisamos tratar como horário de Brasília (UTC-3)
            // Remove o Z e trata como horário local, depois ajusta para UTC-3
            const dataHoraStr = dataItem.data_hora_dado.replace('Z', '');
            // Cria moment sem timezone, depois ajusta para UTC-3 (Brasília)
            const dataHoraBrasilia = moment(dataHoraStr).utcOffset(-180, true); // true = mantém o horário, só muda o offset
            const groupedData: any = { 
              data: dataHoraBrasilia.format('DD/MM/YYYY HH:mm'), 
              timestamp: dataHoraBrasilia.valueOf() 
            };

            if (dataItem.variaveis && Array.isArray(dataItem.variaveis)) {
              const valoresPorTipo: Record<number, { value: any; name: string }> = {};
              dataItem.variaveis.forEach(variavelItem => {
                if (variavelItem.dados && Array.isArray(variavelItem.dados)) {
                  variavelItem.dados.forEach(dadoItem => {
                    const estacaoColetaVariavel = this.estacaoColetas.find(x => {
                      return x.tipo_variavel_id == dadoItem.tipo_variavel.id;
                    });
                    if (this.isVariavelVisivel(dadoItem.tipo_variavel.id, estacaoColetaVariavel)) {
                      let value = this.consolidarValorChuvaAcumuladaCalculada(
                        dadoItem.valor,
                        dadoItem.tipo_variavel.id
                      );
                      value = this.formatarValor(value, dadoItem.tipo_variavel.id);
                      valoresPorTipo[dadoItem.tipo_variavel.id] = {
                        value,
                        name: dadoItem.tipo_variavel.tipo_variavel
                      };
                    }
                  });
                }
              });
              // Aplica valores ao groupedData; se configurado, inverte chuva (3) e chuva acumulada (5)
              Object.keys(valoresPorTipo).forEach(idStr => {
                const id = Number(idStr);
                let value = valoresPorTipo[id].value;
                if (this.deveInverterChuvaChuvaAcumulada()) {
                  if (id === DashboardComponent.TIPO_VARIAVEL_CHUVA && valoresPorTipo[DashboardComponent.TIPO_VARIAVEL_CHUVA_ACUMULADA]) {
                    value = valoresPorTipo[DashboardComponent.TIPO_VARIAVEL_CHUVA_ACUMULADA].value;
                  } else if (id === DashboardComponent.TIPO_VARIAVEL_CHUVA_ACUMULADA && valoresPorTipo[DashboardComponent.TIPO_VARIAVEL_CHUVA]) {
                    value = valoresPorTipo[DashboardComponent.TIPO_VARIAVEL_CHUVA].value;
                  }
                }
                groupedData[valoresPorTipo[id].name] = value;
              });
            }

            this.dadosVariavel.push(groupedData);
            this.sortByKey(this.dadosVariavel, 'timestamp', 'desc');
          });
        }

        // Se houver intervalo_operacao, preenche os intervalos faltantes na tabela
        // Isso deve ser feito mesmo se não houver dados, para criar a série temporal completa
        if (this.intervaloOperacao && this.intervaloOperacao > 0) {
          // Se não houver dados, ainda assim cria os intervalos vazios
          if (this.dadosVariavel.length === 0) {
            this.criarIntervalosVazios(json[0]);
          } else {
            this.preencherIntervalosTabela();
          }
        }

        if (this.dadosVariavel.length > 0) {
          // Cria um mapeamento de nome da variável para tipo_variavel_id usando os dados de json[0]
          const variavelNomeParaId: { [key: string]: number } = {};
          if (json[0] && json[0].length > 0 && json[0][0].tipos_variaveis) {
            json[0][0].tipos_variaveis.forEach((variavel: any) => {
              if (variavel.tipo_variavel && variavel.tipo_variavel.tipo_variavel && variavel.tipo_variavel.id) {
                variavelNomeParaId[variavel.tipo_variavel.tipo_variavel] = variavel.tipo_variavel.id;
              }
            });
          }
          // Incluir nomes para tipos visíveis em estacao_coletas (ex.: chuva acumulada pode não vir em tipos_variaveis)
          this.estacaoColetas.forEach((ec: any) => {
            if (!this.isFlagTrue(ec.visualizar) && !this.isFlagTrue(ec.visible)) return;
            const tipoVariavel = this.tipo_variavel.find((t: any) => t.value == ec.tipo_variavel_id);
            const nome = tipoVariavel?.label || (ec.tipo_variavel_id === DashboardComponent.TIPO_VARIAVEL_CHUVA_ACUMULADA ? 'Chuva acumulada' : ec.tipo_variavel_id === DashboardComponent.TIPO_VARIAVEL_CHUVA ? 'Chuva' : null);
            if (nome && variavelNomeParaId[nome] === undefined) variavelNomeParaId[nome] = ec.tipo_variavel_id;
          });
          
          // Coleta todas as chaves únicas de todos os registros, mas filtra baseado em visible
          const allKeys = new Set<string>();
          this.dadosVariavel.forEach(record => {
            Object.keys(record).forEach(key => {
              // Sempre inclui 'data' e 'timestamp'
              if (key === 'data' || key === 'timestamp') {
                allKeys.add(key);
              } else {
                // Para outras colunas (variáveis), verifica se está visível
                const tipoVariavelId = variavelNomeParaId[key];
                if (tipoVariavelId !== undefined) {
                  const estacaoColetaVariavel = this.estacaoColetas.find(x => {
                    return x.tipo_variavel_id == tipoVariavelId;
                  });
                  
                  // Verifica visibilidade (com regra especial para VAZÃO)
                  if (this.isVariavelVisivel(tipoVariavelId, estacaoColetaVariavel)) {
                    allKeys.add(key);
                  }
                }
              }
            });
          });
          // Incluir colunas para variáveis visíveis em estacao_coletas que não apareceram em nenhum registro
          this.estacaoColetas.forEach((ec: any) => {
            if (!this.isFlagTrue(ec.visualizar) && !this.isFlagTrue(ec.visible)) return;
            const tipoVariavel = this.tipo_variavel.find((t: any) => t.value == ec.tipo_variavel_id);
            const nome = tipoVariavel?.label || (ec.tipo_variavel_id === DashboardComponent.TIPO_VARIAVEL_CHUVA_ACUMULADA ? 'Chuva acumulada' : ec.tipo_variavel_id === DashboardComponent.TIPO_VARIAVEL_CHUVA ? 'Chuva' : null);
            if (nome) allKeys.add(nome);
          });
          this.columnsVariavel = Array.from(allKeys).map(key => ({ field: key, header: key.toUpperCase() }));

          // Preencher com null as colunas que faltam em cada registro (para variáveis visíveis sem dado)
          const colunasVariavel = this.columnsVariavel.filter(c => c.field !== 'data' && c.field !== 'timestamp').map(c => c.field);
          this.dadosVariavel.forEach(record => {
            colunasVariavel.forEach(col => {
              if (record[col] === undefined) record[col] = null;
            });
          });
        }
        
        if (dadosGroupData.estacao.descricao) {
          this.descricao_estacao = dadosGroupData.estacao.descricao;
        }

        this.atualizarCabecalhoRelatorio(dadosGroupData.estacao);
        this.carregarHoraSistemaRelatorio();

        this.initializeCharts();
      }

      // Verifica se não há dados
      const temDadosGroup = json[0] && json[0].length > 0;
      const temDadosFilter = json[1] && (Array.isArray(json[1]) ? json[1].length > 0 : json[1].estacao);
      
      if (!temDadosGroup && !temDadosFilter) {
        this.dados_nao_encontrados = true;
      } else {
        this.dados_nao_encontrados = false;
      }


    }, err => {
      console.log('err', err)
    });
  }

  get exibirCabecalhoRelatorio(): boolean {
    return !!(
      this.descricao_estacao ||
      this.clienteRelatorio ||
      this.horaLeituraRelatorio ||
      this.pluRelatorio ||
      this.fluRelatorio ||
      this.serialTransmissorRelatorio
    );
  }

  abrirSerieHistoricaSnirh(codigo: string | number | null | undefined, tipo: 'PLU' | 'FLU'): void {
    const codigoNormalizado = String(codigo ?? '').trim();

    if (!codigoNormalizado) {
      return;
    }

    this.modalSnirhSerieHistorica = true;
    this.loadingSnirhSerieHistorica = true;
    this.snirhSerieHistoricaTitulo = `Série histórica SNIRH - ${tipo} ${codigoNormalizado}`;
    this.snirhSerieHistoricaHtml = null;

    this._estacaoService.getSnirhSerieHistorica(codigoNormalizado, tipo).subscribe({
      next: (response: any) => {
        this.snirhSerieHistoricaTitulo = response?.titulo || this.snirhSerieHistoricaTitulo;
        this.snirhSerieHistoricaHtml = this.sanitizer.bypassSecurityTrustHtml(response?.html || '');
        this.loadingSnirhSerieHistorica = false;
      },
      error: (error) => {
        this.loadingSnirhSerieHistorica = false;
        this.modalSnirhSerieHistorica = false;
        this.messageService.add({
          severity: 'error',
          summary: 'Falha ao consultar SNIRH',
          detail: error?.error?.message || 'Não foi possível carregar a série histórica no momento.'
        });
      }
    });
  }

  private atualizarCabecalhoRelatorio(estacao: any): void {
    const sensor = estacao?.sensor || estacao?.sensores?.[0] || null;

    this.clienteRelatorio = estacao?.cliente?.nome || '';
    this.pluRelatorio = this.normalizarCodigoAna(estacao?.plu);
    this.fluRelatorio = this.normalizarCodigoAna(estacao?.flu);
    this.serialTransmissorRelatorio = String(sensor?.identificador ?? sensor?.descricao ?? '').trim();
  }

  private carregarHoraSistemaRelatorio(): void {
    if (!this.estacao_id || this.estacao_id === 'null') {
      this.horaLeituraRelatorio = '';
      return;
    }

    this._estacaoService.getStatus(this.estacao_id, moment().format('YYYY-MM-DD')).subscribe({
      next: (response: any) => {
        this.horaLeituraRelatorio = this.formatarHoraLeitura(response?.ultima_data_hora_leitura);
      },
      error: () => {
        this.horaLeituraRelatorio = '';
      }
    });

    this.resumoEventoDiaService.mapDialog(
      Number(this.estacao_id),
      moment().format('YYYY-MM-DD')
    ).subscribe({
      next: (response: any) => {
        const monitoramentos = Array.isArray(response?.monitoramento)
          ? response.monitoramento
          : [];
        this.emMonitoramentoRelatorio = monitoramentos.some(
          (monitoramento: any) => Number(monitoramento?.status) === 0
        );
      },
      error: () => {
        this.emMonitoramentoRelatorio = false;
      }
    });
  }

  private limparCabecalhoRelatorio(): void {
    this.clienteRelatorio = '';
    this.horaLeituraRelatorio = '';
    this.pluRelatorio = '';
    this.fluRelatorio = '';
    this.serialTransmissorRelatorio = '';
    this.emMonitoramentoRelatorio = false;
  }

  private normalizarCodigoAna(valor: any): string {
    const texto = String(valor ?? '').trim();
    return texto && texto !== 'null' ? texto : '';
  }

  private formatarHoraLeitura(valor: string | null | undefined): string {
    if (!valor) {
      return '';
    }

    // Mesma regra da tabela do relatório: o relógio gravado já é Brasília.
    // O Z (ou o offset) da API não pode deslocar a hora.
    const dataHoraStr = String(valor).trim().replace(/\.\d+/, '').replace(/(Z|[+-]\d{2}:?\d{2})$/, '');
    const data = moment(dataHoraStr).utcOffset(-180, true);

    return data.isValid()
      ? `${data.format('DD/MM/YYYY HH:mm:ss')} GMT-3`
      : '';
  }

  private getReportHeader(): string[] {
    const dataInicial = moment(this.rangeDate[0]).format('DD/MM/YYYY');
    const dataFinal = moment(this.rangeDate[1]).format('DD/MM/YYYY');
    const linhaPrincipal = this.descricao_estacao ? `Estação: ${this.descricao_estacao}` : 'Estação: —';
    const linhaSecundaria = [
      this.clienteRelatorio ? `Cliente: ${this.clienteRelatorio}` : null,
      this.horaLeituraRelatorio ? `Última leitura: ${this.horaLeituraRelatorio}` : null,
      `Período: ${dataInicial} a ${dataFinal}`
    ].filter(Boolean).join('  |  ');
    const linhaTerciaria = [
      this.pluRelatorio ? `PLU: ${this.pluRelatorio}` : null,
      this.fluRelatorio ? `FLU: ${this.fluRelatorio}` : null,
      this.serialTransmissorRelatorio ? `Transmissor: ${this.serialTransmissorRelatorio}` : null,
    ].filter(Boolean).join('  |  ');

    return [linhaPrincipal, linhaSecundaria, linhaTerciaria].filter((line) => !!line);
  }

  sortByKey(array, key, type = 'asc') {
    return array.sort(function (a, b) {
      if (type == 'asc') {
        var x = a[key]; var y = b[key];
      } else {
        var x = b[key]; var y = a[key];
      }
      return ((x < y) ? -1 : ((x > y) ? 1 : 0));
    });
  }

  initializeCharts() {
    if (!this.jsonData) return;
    // jsonData já está filtrado para incluir apenas variáveis com visible == true
    this.jsonData.sort((a, b) => a.tipo_variavel.id - b.tipo_variavel.id);
    this.jsonData.forEach((data, index) => {
      this.createChart(data, `chart-${index}`);
    });
  }

  exibirModalMargem: boolean = false;
  indiceGraficoSelecionado: number = -1;
  margemPercentual: number = 10;
  limiteMinimoManual: number | null = null;
  limiteMaximoManual: number | null = null;
  valoresAtuaisGrafico: {
    minimo: number;
    maximo: number;
    media?: number;
  } | null = null;

  /** Exibe o ajuste de escala para os gráficos que possuem dados numéricos. */
  exibirBotaoAjusteMargem(chart: any): boolean {
    return !!chart?.tipo_variavel?.id;
  }

  usaMargemFixaEventosNoGraficoSelecionado(): boolean {
    const tipoVariavelId = Number(
      this.jsonData?.[this.indiceGraficoSelecionado]?.tipo_variavel?.id
    );
    return tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_BATERIA ||
           tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_NIVEL;
  }

  abrirModalAjusteMargem(indice: number): void {
    this.indiceGraficoSelecionado = indice;
    const grafico = this.jsonData[indice];
    this.margemPercentual = grafico.margemPercentual ?? 10;
    
    this.limiteMinimoManual = grafico.limiteMinimoManual ?? null;
    this.limiteMaximoManual = grafico.limiteMaximoManual ?? null;
    
    if (grafico && grafico.dados && grafico.dados.length > 0) {
      const valores = grafico.dados
        .map((d: any) => parseFloat(d.valor_original !== undefined ? d.valor_original : d.valor))
        .filter((v: number) => !isNaN(v) && v !== null);
      
      if (valores.length > 0) {
        const minimo = Math.min(...valores);
        const maximo = Math.max(...valores);
        const media = valores.reduce((a: number, b: number) => a + b, 0) / valores.length;
        
        this.valoresAtuaisGrafico = {
          minimo,
          maximo,
          media
        };
      } else {
        this.valoresAtuaisGrafico = null;
      }
    } else {
      this.valoresAtuaisGrafico = null;
    }
    
    this.exibirModalMargem = true;
  }

  fecharModalMargem(): void {
    this.exibirModalMargem = false;
    this.indiceGraficoSelecionado = -1;
    this.limiteMinimoManual = null;
    this.limiteMaximoManual = null;
    this.valoresAtuaisGrafico = null;
  }

   aplicarMargem(): void {
    if (this.indiceGraficoSelecionado >= 0) {
      if (this.limiteMinimoManual !== null && this.limiteMaximoManual !== null) {
        if (this.limiteMinimoManual >= this.limiteMaximoManual) {
          alert('O limite mínimo deve ser menor que o limite máximo');
          return;
        }
      }
      
      this.atualizarGraficoComMargem(
        this.indiceGraficoSelecionado, 
        this.margemPercentual,
        this.limiteMinimoManual,
        this.limiteMaximoManual
      );
      
      this.fecharModalMargem();
    }
  }

  atualizarGraficoComMargem(
    indice: number, 
    margem: number,
    limiteMinimoManual: number | null = null,
    limiteMaximoManual: number | null = null
  ): void {
    if (indice >= 0 && this.jsonData && this.jsonData[indice]) {
      this.jsonData[indice].margemPercentual = margem;
      this.jsonData[indice].limiteMinimoManual = limiteMinimoManual;
      this.jsonData[indice].limiteMaximoManual = limiteMaximoManual;
      
      const chartInstance = this.jsonData[indice].chartInstance;
      if (chartInstance) {
        this.configureChart(chartInstance, this.jsonData[indice], `chart-${indice}`);
      } else {
        setTimeout(() => {
          this.createChart(this.jsonData[indice], `chart-${indice}`);
        }, 100);
      }
    }
  }

  createChart(data: any, elementId: string) {
    // jsonData já está filtrado, então não precisa verificar visible novamente
    // Mas mantemos a verificação como segurança
    let estacaoColetaVariavel = this.estacaoColetas.find(x => { 
      return x.tipo_variavel_id == data.tipo_variavel.id 
    });

    // Verifica visibilidade (com regra especial para VAZÃO)
    if (this.isVariavelVisivel(data.tipo_variavel.id, estacaoColetaVariavel)) {
      setTimeout(() => {
        let chartElement = document.getElementById(elementId);
        if (chartElement) {
          const chart = echarts.init(chartElement);
          
          data.chartInstance = chart;
          
          this.configureChart(chart, data, elementId);
          
          window.addEventListener('resize', () => {
            chart.resize();
          });
        }
      }, 2000);
    }
  }

  configureChart(chart: any, data: any, elementId: string) {
    // Obtém a data/hora atual em Brasília como limite máximo
    const dataAtualBrasilia = this.getDataAtualBrasilia();
    const tipoVariavelId = Number(data?.tipo_variavel?.id);

    // Garante que data.dados existe
    if (!data.dados) {
      data.dados = [];
    }
    
    // Processa todos os dados (incluindo vazios) e limita até a hora atual de Brasília
    // Mantém intervalos vazios como null para que o gráfico corte nessas partes
    const dadosProcessados = (data.dados || [])
      .filter((item: any) => {
        // Verifica se o timestamp não é futuro (limite de Brasília)
        if (!item || (!item.timestamp && !item.data_hora_dado)) {
          return false;
        }
        const timestamp = item.timestamp || moment(item.data_hora_dado, 'DD/MM/YYYY HH:mm:ss').utcOffset(-180).valueOf();
        return !moment(timestamp).utcOffset(-180).isAfter(dataAtualBrasilia);
      })
      .sort((a: any, b: any) => {
        // Ordena por timestamp
        const timestampA = a.timestamp || moment(a.data_hora_dado, 'DD/MM/YYYY HH:mm:ss').utcOffset(-180).valueOf();
        const timestampB = b.timestamp || moment(b.data_hora_dado, 'DD/MM/YYYY HH:mm:ss').utcOffset(-180).valueOf();
        return timestampA - timestampB;
      });
    
    const xAxisData = dadosProcessados.map((item: any) => this.formatChartDate(item.data_hora_dado));
    // Usa valor_original se disponível, senão usa valor
    // Se o valor for vazio/nulo, retorna null para que o gráfico corte nessa parte
    const seriesData = dadosProcessados.map((item: any) => {
      const valorParaUsar = item.valor_original !== undefined && item.valor_original !== null ? item.valor_original : item.valor;
      const valor = parseFloat(valorParaUsar);
      // Retorna null se o valor for inválido, para que o gráfico corte nessa parte
      if (isNaN(valor) || valorParaUsar === null || valorParaUsar === undefined || valorParaUsar === '') {
        return null;
      }
      return valor;
    });
    const additionalSeries = this.getAdditionalSeries(
      data.tipo_variavel.id,
      data.tipo_variavel.tipo_variavel,
      xAxisData.length
    );
    const legendEntries = additionalSeries.map(series => series.name).filter(name => !!name);
    const temLegenda = legendEntries.length > 0;
    // A legenda fica abaixo da faixa azul do visualizador, com folga para os rótulos não subirem nela.
    const sliderBottom = temLegenda ? 46 : 10;
    const sliderHeight = temLegenda ? 16 : 20;
    const gridBottom = temLegenda ? 116 : 60;
    
    // Filtra valores null/undefined para calcular min/max apenas dos valores válidos
    const valoresValidos = seriesData.filter((val: any) => val !== null && val !== undefined && !isNaN(val));
    
    const temLimiteMinimoManual = data.limiteMinimoManual !== undefined && data.limiteMinimoManual !== null;
    const temLimiteMaximoManual = data.limiteMaximoManual !== undefined && data.limiteMaximoManual !== null;
    const linhasRef = this.getValoresLinhasReferencia(tipoVariavelId);
    const limitesEvento = this.getLimitesEscalaEventos(tipoVariavelId);
    const usaEscalaReferencia =
      (limitesEvento.minimo !== null || limitesEvento.maximo !== null) &&
      (
        tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_BATERIA ||
        tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_NIVEL
      );
    const margemPercentualGrafico = data.margemPercentual != null ? Number(data.margemPercentual) : 10;
    const marginPercent = (Number.isFinite(margemPercentualGrafico) ? margemPercentualGrafico : 10) / 100;

    let minDataValue: number | undefined;
    let maxDataValue: number | undefined;
    let baseMin = 0;
    let baseMax = 1;
    let yAxisMin: number | undefined;
    let yAxisMax: number | undefined;
    let usaEscalaBaseadaNasLinhas = false;

    if (temLimiteMinimoManual && temLimiteMaximoManual) {
      yAxisMin = data.limiteMinimoManual;
      yAxisMax = data.limiteMaximoManual;
      if (yAxisMin >= yAxisMax) {
        yAxisMax = yAxisMin + 1;
      }
    } else if (usaEscalaReferencia) {
      // Bateria/Nível: margem absoluta fixa de uma unidade sobre os limites
      // semânticos de cada evento. Leituras não expandem lados configurados.
      const valoresSemPicos = this.filtrarPicosEscalaY(valoresValidos);
      const minimoDados = valoresSemPicos.length > 0 ? Math.min(...valoresSemPicos) : null;
      const maximoDados = valoresSemPicos.length > 0 ? Math.max(...valoresSemPicos) : null;
      const configuracaoInconsistente =
        limitesEvento.minimo !== null &&
        limitesEvento.maximo !== null &&
        limitesEvento.minimo >= limitesEvento.maximo;
      const minimoEvento = configuracaoInconsistente ? null : limitesEvento.minimo;
      const maximoEvento = configuracaoInconsistente ? null : limitesEvento.maximo;

      yAxisMin = temLimiteMinimoManual
        ? data.limiteMinimoManual
        : minimoEvento !== null
          ? minimoEvento - 1
          : minimoDados !== null
            ? minimoDados - 1
            : maximoEvento !== null
              ? maximoEvento - 1
              : 0;
      yAxisMax = temLimiteMaximoManual
        ? data.limiteMaximoManual
        : maximoEvento !== null
          ? maximoEvento + 1
          : maximoDados !== null
            ? maximoDados + 1
            : minimoEvento !== null
              ? minimoEvento + 1
              : 100;

      // Um limite manual parcial sempre prevalece. Se ele tornar o intervalo
      // inválido, ajusta somente o lado automático.
      if (yAxisMin >= yAxisMax) {
        if (temLimiteMinimoManual) {
          yAxisMax = maximoDados !== null && maximoDados + 1 > yAxisMin
            ? maximoDados + 1
            : yAxisMin + 1;
        } else if (temLimiteMaximoManual) {
          yAxisMin = minimoDados !== null && minimoDados - 1 < yAxisMax
            ? minimoDados - 1
            : yAxisMax - 1;
        } else if (minimoDados !== null && maximoDados !== null) {
          yAxisMin = minimoDados - 1;
          yAxisMax = maximoDados + 1;
        } else {
          yAxisMin = 0;
          yAxisMax = 100;
        }
      }
      usaEscalaBaseadaNasLinhas = true;
    } else {
      const valoresParaEscala = (
        tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_BATERIA ||
        tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_NIVEL
      ) ? this.filtrarPicosEscalaY(valoresValidos) : valoresValidos;
      const valoresEscala = valoresParaEscala.length > 0 ? valoresParaEscala : valoresValidos;

      if (valoresEscala.length === 0) {
        // Se não há valores válidos, usa valores padrão
        minDataValue = 0;
        maxDataValue = 100;
        baseMin = minDataValue;
        baseMax = maxDataValue;
      } else if (temLimiteMinimoManual) {
        yAxisMin = data.limiteMinimoManual;
        
        if (valoresEscala.length > 0) {
          maxDataValue = Math.max(...valoresEscala);
          const margemAutomatica = Math.abs(maxDataValue * marginPercent);
          yAxisMax = maxDataValue + margemAutomatica;
          // O limite manual mínimo sempre deve permanecer no lado inferior
          // do eixo, mesmo quando todos os dados estão abaixo dele.
          if (yAxisMax <= yAxisMin) {
            yAxisMax = yAxisMin + (margemAutomatica || 1);
          }
        } else {
          yAxisMax = yAxisMin + 10;
        }
      } else if (temLimiteMaximoManual) {
        yAxisMax = data.limiteMaximoManual;
        
        if (valoresEscala.length > 0) {
          minDataValue = Math.min(...valoresEscala);
          const margemAutomatica = Math.abs(minDataValue * marginPercent);
          yAxisMin = minDataValue - margemAutomatica;
          // O limite manual máximo sempre deve permanecer no lado superior
          // do eixo, mesmo quando todos os dados estão acima dele.
          if (yAxisMin >= yAxisMax) {
            yAxisMin = yAxisMax - (margemAutomatica || 1);
          }
        } else {
          yAxisMin = yAxisMax - 10;
        }
      } else if (data.margemPercentual == null) {
        // Demais gráficos: ao abrir, 1 unidade abaixo do menor valor do intervalo
        // e 1 acima do maior. Os limites do cadastro não encolhem nem ampliam essa escala.
        minDataValue = Math.min(...valoresEscala);
        maxDataValue = Math.max(...valoresEscala);
        yAxisMin = minDataValue - 1;
        yAxisMax = maxDataValue + 1;
      } else {
        minDataValue = Math.min(...valoresEscala);
        maxDataValue = Math.max(...valoresEscala);

        // Linhas dinâmicas da estação (configuracoes_evento): bateria=1/2, nível/radar/genéricos=5
        const temLinhasRef = linhasRef.length > 0;
        const linhaMin = temLinhasRef ? Math.min(...linhasRef) : null;
        const linhaMax = temLinhasRef ? Math.max(...linhasRef) : null;

        // Margem percentual só depois que o usuário aplica o ajuste manual.
        const filtroMin = this.parseLimiteTipoVariavel(data.tipo_variavel.limite_minimo);
        const filtroMax = this.parseLimiteTipoVariavel(data.tipo_variavel.limite_maximo);
        baseMax = Math.max(
          filtroMax != null ? filtroMax : Number.NEGATIVE_INFINITY,
          linhaMax != null ? linhaMax : Number.NEGATIVE_INFINITY
        );
        if (!Number.isFinite(baseMax)) {
          baseMax = maxDataValue;
        }
        baseMax = Math.max(baseMax, maxDataValue);

        baseMin = Math.min(
          filtroMin != null ? filtroMin : Number.POSITIVE_INFINITY,
          linhaMin != null ? linhaMin : Number.POSITIVE_INFINITY
        );
        if (!Number.isFinite(baseMin)) {
          baseMin = minDataValue;
        }
        baseMin = Math.min(baseMin, minDataValue);
      }
      
      if (yAxisMin === undefined || yAxisMax === undefined) {
        // Sempre aplica a margem percentual (ex.: +10% no topo e -10% na base em relação a baseMax/baseMin)
        yAxisMin = baseMin - Math.abs(baseMin * marginPercent);
        yAxisMax = baseMax + Math.abs(baseMax * marginPercent);
      }

      if (data.margemPercentual != null && !usaEscalaBaseadaNasLinhas && minDataValue !== undefined && minDataValue === maxDataValue) {
        // Só recentra no valor único quando a escala não está ancorada nas linhas de referência.
        const singleValue = minDataValue;
        if (singleValue === 0) {
          yAxisMin = -1;
          yAxisMax = 1;
        } else {
          yAxisMin = singleValue - Math.abs(singleValue * 0.5);
          yAxisMax = singleValue + Math.abs(singleValue * 0.5);
        }
      }
      
      if (yAxisMin >= yAxisMax) {
        const diff = Math.abs(yAxisMax - yAxisMin);
        if (diff === 0) {
          const adjustment = Math.abs(baseMax * marginPercent);
          yAxisMin = baseMin - adjustment;
          yAxisMax = baseMax + adjustment;
        } else {
          [yAxisMin, yAxisMax] = [Math.min(yAxisMin, yAxisMax), Math.max(yAxisMin, yAxisMax)];
        }
      }
    }

    if (yAxisMin === undefined || yAxisMax === undefined) {
      yAxisMin = 0;
      yAxisMax = 1;
    }

    if (yAxisMin === yAxisMax) {
      yAxisMin = yAxisMin - 1;
      yAxisMax = yAxisMax + 1;
    }

    const eixoMin = yAxisMin;
    const eixoMax = yAxisMax;
    const deveRecortarSerie = usaEscalaReferencia || usaEscalaBaseadaNasLinhas ||
      tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_BATERIA ||
      tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_NIVEL;

    const quantidadeLeiturasForaEscala = deveRecortarSerie
      ? seriesData.filter((valor: number | null) =>
          valor !== null && valor !== undefined && (valor < eixoMin || valor > eixoMax)
        ).length
      : 0;
    data.quantidadeLeiturasForaEscala = quantidadeLeiturasForaEscala;

    const seriesDataNoEixo = seriesData.map((valor: number | null) => {
      if (valor === null || valor === undefined || Number.isNaN(valor)) {
        return null;
      }
      // Abaixo da escala a leitura some, sem faixa, símbolo ou rótulo de “fora”.
      if (valor < eixoMin) {
        return null;
      }
      // Acima da escala o ponto fica no topo, para o degradê da própria série
      // preencher a área como quando o valor está dentro do eixo.
      if (valor > eixoMax) {
        return {
          value: eixoMax,
          valorOriginal: valor
        };
      }
      return valor;
    });

    // Obtém a cor da linha baseada no tipo de variável
    const corLinha = this.getCorLinhaVariavel(data.tipo_variavel.id);
    
    // Configura a série principal com preenchimento e corte de valores vazios
    const seriePrincipal: any = {
      name: data.tipo_variavel.tipo_variavel,
      data: seriesDataNoEixo,
      type: data.tipo_variavel.tipo_grafico,
      smooth: false,
      clip: true,
      connectNulls: false, // Corta o gráfico quando há valores vazios (deixa branco)
      triggerLineEvent: true, // Permite tooltip mesmo em valores null
      lineStyle: {
        color: corLinha,
        width: 2
      },
      itemStyle: {
        color: corLinha
      },
      emphasis: {
        focus: 'series'
      }
    };

    // Adiciona preenchimento apenas para gráficos de linha
    if (data.tipo_variavel.tipo_grafico === 'line') {
      const gradiente = this.getGradientePreenchimento(corLinha);
      seriePrincipal.areaStyle = {
        color: {
          type: 'linear',
          x: 0,
          y: 0,
          x2: 0,
          y2: 1,
          colorStops: [{
            offset: 0,
            color: gradiente.top // Mais clara que a linha
          }, {
            offset: 1,
            color: gradiente.bottom // Ainda mais clara na base
          }]
        }
      };
    }

    let option: any = {
      tooltip: {
        trigger: 'axis',
        show: true,
        showContent: true,
        alwaysShowContent: false,
        axisPointer: {
          type: 'line',
          label: {
            show: true
          }
        },
        formatter: (params: any) => {
          if (!params || !Array.isArray(params) || params.length === 0) {
            return '';
          }
          
          const valorTooltip = (ponto: any): number | null => {
            const bruto = ponto?.data;
            if (bruto === null || bruto === undefined) {
              return null;
            }
            const candidato = typeof bruto === 'object' ? (bruto.valorOriginal ?? bruto.value) : bruto;
            const numero = typeof candidato === 'number' ? candidato : parseFloat(candidato);
            return Number.isNaN(numero) ? null : numero;
          };

          // Filtra apenas séries com dados válidos (não null)
          const validParams = params.filter((p: any) => valorTooltip(p) !== null);
          
          if (validParams.length === 0) {
            // Se não há dados válidos, mostra apenas a data/hora
            const point = params[0];
            if (point && point.axisValue !== undefined) {
              return `${point.axisValue}<br />Sem dados disponíveis`;
            }
            return '';
          }
          
          // Usa o primeiro parâmetro válido
          const point = validParams[0];
          if (!point || point.axisValue === undefined) {
            return '';
          }
          
          let tooltipContent = `${point.axisValue}<br />`;
          
          // Adiciona todas as séries válidas ao tooltip
          validParams.forEach((p: any) => {
            const formattedValue = this.formatarValor(valorTooltip(p) as number, data.tipo_variavel.id);
            const marker = p.marker || '';
            tooltipContent += `${marker}${p.seriesName}: ${formattedValue}<br />`;
          });
          
          return tooltipContent;
        }
      },
      xAxis: {
        type: 'category',
        data: xAxisData,
        axisLabel: {
          formatter: (value: string) => value,
        },
      },
      yAxis: {
        type: 'value',
        min: () => eixoMin,
        max: () => eixoMax,
        axisLabel: {
          formatter: (value: number) => {
            return this.formatarValor(value, data.tipo_variavel.id);
          },
        },
      },
      dataZoom: [
        {
          type: 'inside',
          xAxisIndex: 0,
          start: 0,
          end: 100
        },
        {
          show: true,
          type: 'slider',
          xAxisIndex: 0,
          bottom: sliderBottom,
          height: sliderHeight,
          start: 40,
          end: 100
        }
      ],
      series: [seriePrincipal, ...additionalSeries],
    };

    if (legendEntries.length) {
      option.legend = {
        data: legendEntries,
        bottom: 0,
        padding: [0, 8, 2, 8],
        itemHeight: 10,
        itemGap: 16
      };
      option.grid = {
        bottom: gridBottom
      };
    }

    chart.setOption(option);
  }

  // createChart(data: any, elementId: string) {
  //   let estacaoColetaVariavel = this.estacaoColetas.find(x => { 
  //     return x.tipo_variavel_id == data.tipo_variavel.id 
  //   });

  //   if (estacaoColetaVariavel !== undefined && estacaoColetaVariavel.visualizar == true) {
  //     setTimeout(() => {
  //       let chartElement = document.getElementById(elementId);
  //       if (chartElement) {
  //         const chart = echarts.init(chartElement);

  //         const xAxisData = data.dados.map((item: any) => this.formatChartDate(item.data_hora_dado));
  //         const seriesData = data.dados.map((item: any) => parseFloat(item.valor));
  //         const additionalSeries = this.getAdditionalSeries(data.tipo_variavel.tipo_variavel, xAxisData.length);
  //         const legendEntries = additionalSeries.map(series => series.name).filter(name => !!name);
  //         const sliderBottom = legendEntries.length ? 40 : 10;
  //         const gridBottom = legendEntries.length ? 80 : 60;
          
  //         const minDataValue = Math.min(...seriesData);
  //         const maxDataValue = Math.max(...seriesData);
          
  //         let baseMin = minDataValue;
  //         if (data.tipo_variavel.limite_minimo !== undefined && data.tipo_variavel.limite_minimo !== null) {
  //           baseMin = Math.min(minDataValue, data.tipo_variavel.limite_minimo);
  //         }
          
  //         let baseMax = maxDataValue;
  //         if (data.tipo_variavel.limite_maximo !== undefined && data.tipo_variavel.limite_maximo !== null) {
  //           baseMax = Math.max(maxDataValue, data.tipo_variavel.limite_maximo);
  //         }
          
  //         const marginPercent = 0.1;
          
  //         let yAxisMin = baseMin - Math.abs(baseMin * marginPercent);
  //         let yAxisMax = baseMax + Math.abs(baseMax * marginPercent);
          
  //         if (minDataValue === maxDataValue) {
  //           const singleValue = minDataValue;
  //           if (singleValue === 0) {
  //             yAxisMin = -1;
  //             yAxisMax = 1;
  //           } else {
  //             yAxisMin = singleValue - Math.abs(singleValue * 0.5);
  //             yAxisMax = singleValue + Math.abs(singleValue * 0.5);
  //           }
  //         }
          
  //         if (yAxisMin >= yAxisMax) {
  //           const diff = Math.abs(yAxisMax - yAxisMin);
  //           if (diff === 0) {
  //             const adjustment = Math.abs(baseMax * marginPercent);
  //             yAxisMin = baseMin - adjustment;
  //             yAxisMax = baseMax + adjustment;
  //           } else {
  //             [yAxisMin, yAxisMax] = [Math.min(yAxisMin, yAxisMax), Math.max(yAxisMin, yAxisMax)];
  //           }
  //         }
          
  //         if (yAxisMin === yAxisMax) {
  //           yAxisMin = yAxisMin - 1;
  //           yAxisMax = yAxisMax + 1;
  //         }

  //         let option: any = {
  //           tooltip: {
  //             trigger: 'axis',
  //             formatter: (params: any) => {
  //               const point = params[0];
  //               let formattedValue = point.data;
  //               formattedValue = parseFloat(point.data).toFixed(1).replace('.', ',');
  //               return `${point.axisValue}<br />${data.tipo_variavel.tipo_variavel}: ${formattedValue}`;
  //             }
  //           },
  //           xAxis: {
  //             type: 'category',
  //             data: xAxisData,
  //             axisLabel: {
  //               formatter: (value: string) => value,
  //             },
  //           },
  //           yAxis: {
  //             type: 'value',
  //             min: yAxisMin,
  //             max: yAxisMax,
  //             axisLabel: {
  //               formatter: (value: number) => {
  //                 if (data.tipo_variavel.id === DashboardComponent.TIPO_VARIAVEL_BATERIA || data.tipo_variavel.id === DashboardComponent.TIPO_VARIAVEL_NIVEL) {
  //                   return value.toFixed(1).replace('.', ',');
  //                 }
  //                 return value.toString();
  //               },
  //             },
  //           },
  //           dataZoom: [
  //             {
  //               type: 'inside',
  //               start: 0,
  //               end: 100
  //             },
  //             {
  //               show: true,
  //               type: 'slider',
  //               bottom: sliderBottom,
  //               start: 40,
  //               end: 100
  //             }
  //           ],
  //           series: [{
  //             name: data.tipo_variavel.tipo_variavel,
  //             data: seriesData,
  //             type: data.tipo_variavel.tipo_grafico,
  //             smooth: false,
  //           }, ...additionalSeries],
  //         };

  //         if (legendEntries.length) {
  //           option.legend = {
  //             data: legendEntries,
  //             bottom: 0
  //           };
  //           option.grid = {
  //             bottom: gridBottom
  //           };
  //         }

  //         chart.setOption(option);
          
  //         window.addEventListener('resize', () => {
  //           chart.resize();
  //         });
  //       }
  //     }, 2000);
  //   }
  // }

  addNovoGrupo() {
    this.modalNovoGrupo = true
  }

  aoSalvarNovoGrupo(): void {
    this.listGrupos()
    this.modalNovoGrupo = false;
  }

  private formatChartDate(dateString: string): string {
    return dateString;
  }

  /** Limites numéricos do tipo de variável (filtro cadastro) para o eixo Y. */
  private parseLimiteTipoVariavel(limite: any): number | null {
    if (limite === undefined || limite === null || limite === '') {
      return null;
    }
    return this.parseConfigValue(limite);
  }

  /**
   * Valores Y de todas as linhas de referência (mesma regra que getAdditionalSeries), para combinar com limite_minimo/máximo do filtro no eixo.
   */
  private getValoresLinhasReferencia(tipoVariavelId: number): number[] {
    const valores: number[] = [];

    if (
      tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_VAZAO ||
      tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_CHUVA ||
      tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_CHUVA_ACUMULADA
    ) {
      return valores;
    }

    if (tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_BATERIA) {
      const minCfg = this.getConfiguracaoEvento(1);
      if (minCfg?.valor_parametro != null) {
        const v = this.parseConfigValue(minCfg.valor_parametro);
        if (v !== null) {
          valores.push(v);
        }
      }
      const maxCfg = this.getConfiguracaoEvento(2);
      if (maxCfg?.valor_parametro != null) {
        const v = this.parseConfigValue(maxCfg.valor_parametro);
        if (v !== null) {
          valores.push(v);
        }
      }
    } else if (
      tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_NIVEL ||
      tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_RADAR ||
      tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_VAZAO
    ) {
      const cfg = this.getConfiguracaoEvento(5);
      if (cfg) {
        if (cfg.valor_minimo != null) {
          const v = this.parseConfigValue(cfg.valor_minimo);
          if (v !== null) {
            valores.push(v);
          }
        }
        if (cfg.valor_maximo != null) {
          const v = this.parseConfigValue(cfg.valor_maximo);
          if (v !== null) {
            valores.push(v);
          }
        }
      }
    } else {
      const cfg = this.getConfiguracaoEvento(5);
      if (cfg) {
        if (cfg.valor_minimo != null) {
          const v = this.parseConfigValue(cfg.valor_minimo);
          if (v !== null) {
            valores.push(v);
          }
        }
        if (cfg.valor_maximo != null) {
          const v = this.parseConfigValue(cfg.valor_maximo);
          if (v !== null) {
            valores.push(v);
          }
        }
      }
    }

    return valores;
  }

  /** Limites semânticos usados pela escala automática de Bateria e Nível. */
  private getLimitesEscalaEventos(tipoVariavelId: number): { minimo: number | null; maximo: number | null } {
    if (tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_BATERIA) {
      const bateriaBaixa = this.getConfiguracaoEvento(1);
      const painelBaixaPotencia = this.getConfiguracaoEvento(2);
      return {
        minimo: this.parseConfigValue(bateriaBaixa?.valor_parametro),
        maximo: this.parseConfigValue(painelBaixaPotencia?.valor_parametro)
      };
    }

    if (tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_NIVEL) {
      const nivelForaDosLimites = this.getConfiguracaoEvento(5);
      return {
        minimo: this.parseConfigValue(nivelForaDosLimites?.valor_minimo),
        maximo: this.parseConfigValue(nivelForaDosLimites?.valor_maximo)
      };
    }

    return { minimo: null, maximo: null };
  }

  private getAdditionalSeries(tipoVariavelId: number, variableName: string, dataLength: number): any[] {
    const series: any[] = [];
    if (!dataLength) {
      return series;
    }
    const variableLabelLower = (variableName || `variavel ${tipoVariavelId}`).toLowerCase();

    // Vazão, Chuva e Chuva Acumulada não possuem linhas de máximo/mínimo
    if (
      tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_VAZAO ||
      tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_CHUVA ||
      tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_CHUVA_ACUMULADA
    ) {
      return series;
    }
    
    if (tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_BATERIA) {
      const minCfg = this.getConfiguracaoEvento(1);
      if (minCfg && minCfg.valor_parametro != null) {
        const value = this.parseConfigValue(minCfg.valor_parametro);
        if (value !== null) {
          const name = `min p/ bateria baixa (${this.formatLegendValue(value)})`;
          series.push(this.buildConstantLineSeries(name, value, dataLength, '#FF6B35'));
        }
      }

      const maxCfg = this.getConfiguracaoEvento(2);
      if (maxCfg && maxCfg.valor_parametro != null) {
        const value = this.parseConfigValue(maxCfg.valor_parametro);
        if (value !== null) {
          const name = `min p/ baixa painel potencia (${this.formatLegendValue(value)})`;
          series.push(this.buildConstantLineSeries(name, value, dataLength, '#FFA500'));
        }
      }
    } else if (
      tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_NIVEL ||
      tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_RADAR ||
      tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_VAZAO
    ) {
      const cfg = this.getConfiguracaoEvento(5);
      if (cfg) {
        if (cfg.valor_minimo != null) {
          const minValue = this.parseConfigValue(cfg.valor_minimo);
          if (minValue !== null) {
            const name = `${variableLabelLower} min (${this.formatLegendValue(minValue)})`;
            series.push(this.buildConstantLineSeries(name, minValue, dataLength, '#4A90E2'));
          }
        }

        if (cfg.valor_maximo != null) {
          const maxValue = this.parseConfigValue(cfg.valor_maximo);
          if (maxValue !== null) {
            const name = `${variableLabelLower} max (${this.formatLegendValue(maxValue)})`;
            series.push(this.buildConstantLineSeries(name, maxValue, dataLength, '#4A90E2'));
          }
        }
      }
    } else {
      // Para variáveis genéricas, verifica se há configurações de min/max
      const cfg = this.getConfiguracaoEvento(5);
      if (cfg) {
        if (cfg.valor_minimo != null) {
          const minValue = this.parseConfigValue(cfg.valor_minimo);
          if (minValue !== null) {
            const name = `${variableLabelLower} min (${this.formatLegendValue(minValue)})`;
            series.push(this.buildConstantLineSeries(name, minValue, dataLength, '#4A90E2'));
          }
        }

        if (cfg.valor_maximo != null) {
          const maxValue = this.parseConfigValue(cfg.valor_maximo);
          if (maxValue !== null) {
            const name = `${variableLabelLower} max (${this.formatLegendValue(maxValue)})`;
            series.push(this.buildConstantLineSeries(name, maxValue, dataLength, '#4A90E2'));
          }
        }
      }
    }

    return series;
  }

  private getConfiguracaoEvento(configuracaoId: number): any {
    return this.estacaoConfiguracoesEvento?.find(item =>
      Number(item.configuracao_evento_id) === Number(configuracaoId)
    );
  }

  /**
   * Remove picos isolados do cálculo da escala Y automática (ex.: 170 V numa bateria de ~16 V).
   */
  private filtrarPicosEscalaY(valores: number[]): number[] {
    if (!valores || valores.length === 0) {
      return [];
    }
    if (valores.length < 4) {
      return [...valores];
    }

    const ordenados = [...valores].sort((a, b) => a - b);
    const q1 = this.percentile(ordenados, 0.25);
    const q3 = this.percentile(ordenados, 0.75);
    const iqr = q3 - q1;

    if (iqr === 0) {
      const mediana = ordenados[Math.floor(ordenados.length / 2)];
      const tolerancia = Math.max(Math.abs(mediana) * 0.5, 1);
      return valores.filter(v => Math.abs(v - mediana) <= tolerancia);
    }

    const cerca = 3 * iqr;
    return valores.filter(v => v >= q1 - cerca && v <= q3 + cerca);
  }

  private percentile(ordenados: number[], p: number): number {
    if (ordenados.length === 1) {
      return ordenados[0];
    }
    const indice = (ordenados.length - 1) * p;
    const baixo = Math.floor(indice);
    const alto = Math.ceil(indice);
    if (baixo === alto) {
      return ordenados[baixo];
    }
    const peso = indice - baixo;
    return ordenados[baixo] * (1 - peso) + ordenados[alto] * peso;
  }

  private formatLegendValue(value: number): string {
    return Number(value).toFixed(2).replace('.', ',');
  }

  private buildConstantLineSeries(name: string, value: number, dataLength: number, color: string) {
    return {
      name,
      type: 'line',
      data: Array(dataLength).fill(value),
      symbol: 'none',
      lineStyle: {
        color,
        width: 1.5
      },
      tooltip: {
        show: false
      },
      emphasis: {
        disabled: true
      }
    };
  }

  private parseConfigValue(value: any): number | null {
    if (value === undefined || value === null) {
      return null;
    }
    const normalized = typeof value === 'string' ? value.replace(',', '.') : value;
    const parsed = parseFloat(normalized);

    return isNaN(parsed) ? null : parsed;
  }

  /** Aceita true/1/'1'/'true' para flags vindas da API. */
  private isFlagTrue(value: any): boolean {
    return value === true || value === 1 || value === '1' || value === 'true';
  }

  /**
   * Obtém a cor da linha baseada no ID do tipo de variável
   */
  private getCorLinhaVariavel(tipoVariavelId: number): string {
    if (tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_NIVEL) {
      return '#1565C0';
    } else if (tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_BATERIA) {
      return '#FF9500';
    } else if (tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_VAZAO) {
      return '#87CEEB';
    } else if (tipoVariavelId === DashboardComponent.TIPO_VARIAVEL_RADAR) {
      return '#7E57C2';
    } else {
      // Genérico
      return '#1f77b4';
    }
  }

  /**
   * Converte cor hex para rgba e cria gradiente de preenchimento
   * Retorna um gradiente mais claro que a cor da linha
   */
  private getGradientePreenchimento(corHex: string): { top: string; bottom: string } {
    // Remove o # se existir
    const hex = corHex.replace('#', '');
    
    // Converte hex para RGB
    const r = parseInt(hex.substring(0, 2), 16);
    const g = parseInt(hex.substring(2, 4), 16);
    const b = parseInt(hex.substring(4, 6), 16);
    
    // Cria gradiente: topo mais claro (0.5 de opacidade) e base ainda mais clara (0.15 de opacidade)
    return {
      top: `rgba(${r}, ${g}, ${b}, 0.5)`, // Mais clara que a linha
      bottom: `rgba(${r}, ${g}, ${b}, 0.15)` // Ainda mais clara na base
    };
  }

  /**
   * Verifica se uma variável deve ser visível
   * Para VAZÃO (tipo_variavel_id=4): visible == true OU exibir_vazao == true
   * Para outras variáveis: apenas visible == true (requer estacaoColetaVariavel)
   */
  private isVariavelVisivel(tipoVariavelId: number, estacaoColetaVariavel: any): boolean {
    // Se for VAZÃO (tipo_variavel_id=4), verifica exibir_vazao mesmo sem estacaoColetaVariavel
    if (tipoVariavelId == 4) {
      if (this.exibirVazao == true) {
        return true;
      }
    }

    // Para todas as variáveis, verifica estacaoColetaVariavel
    if (!estacaoColetaVariavel) {
      return false;
    }

    // Verifica visible (ou visualizar como fallback)
    const isVisible = estacaoColetaVariavel.visible !== undefined
      ? this.isFlagTrue(estacaoColetaVariavel.visible)
      : this.isFlagTrue(estacaoColetaVariavel.visualizar);

    // Se for VAZÃO (tipo_variavel_id=4), também aceita se exibir_vazao for true
    if (tipoVariavelId == 4) {
      return isVisible || this.exibirVazao == true;
    }

    return isVisible;
  }

  /**
   * Quando a estação calcula chuva a partir da chuva acumulada (tipo 5 visível),
   * os valores calculados ficam em tipo_variavel_id=5. Valores negativos (ex.: reset do pluviômetro)
   * são consolidados como 0.
   */
  private consolidarValorChuvaAcumuladaCalculada(valor: any, tipoVariavelId: number): any {
    if (!this.deveInverterChuvaChuvaAcumulada()) {
      return valor;
    }
    if (tipoVariavelId !== DashboardComponent.TIPO_VARIAVEL_CHUVA_ACUMULADA) {
      return valor;
    }
    if (valor === null || valor === undefined || valor === '') {
      return valor;
    }
    const numValue = typeof valor === 'string' ? parseFloat(valor) : valor;
    if (isNaN(numValue)) {
      return valor;
    }
    return numValue < 0 ? 0 : valor;
  }

  /**
   * Quando estacao_coletas tem tipo_variavel_id=5 (chuva acumulada) com visualizar=true,
   * devemos inverter na tela: mostrar valor de chuva (3) na coluna chuva acumulada (5) e vice-versa.
   */
  private deveInverterChuvaChuvaAcumulada(): boolean {
    const chuvaAcumulada = this.estacaoColetas.find(
      (x: any) => x.tipo_variavel_id == DashboardComponent.TIPO_VARIAVEL_CHUVA_ACUMULADA
    );
    if (!chuvaAcumulada) return false;
    const visualizar = this.isFlagTrue(chuvaAcumulada.visualizar) || this.isFlagTrue(chuvaAcumulada.visible);
    return !!visualizar;
  }

  /**
   * Troca os arrays de dados (dados) entre as séries Chuva (tipo 3) e Chuva acumulada (tipo 5) no jsonData.
   * Usado quando deveInverterChuvaChuvaAcumulada() é true.
   */
  private inverterValoresChuvaChuvaAcumuladaJsonData(): void {
    if (!this.jsonData || this.jsonData.length === 0) return;
    const idxChuva = this.jsonData.findIndex((v: any) => v.tipo_variavel && v.tipo_variavel.id == DashboardComponent.TIPO_VARIAVEL_CHUVA);
    const idxChuvaAcumulada = this.jsonData.findIndex((v: any) => v.tipo_variavel && v.tipo_variavel.id == DashboardComponent.TIPO_VARIAVEL_CHUVA_ACUMULADA);
    if (idxChuva === -1 || idxChuvaAcumulada === -1) return;
    const dadosChuva = this.jsonData[idxChuva].dados;
    const dadosChuvaAcumulada = this.jsonData[idxChuvaAcumulada].dados;
    this.jsonData[idxChuva] = { ...this.jsonData[idxChuva], dados: dadosChuvaAcumulada || [] };
    this.jsonData[idxChuvaAcumulada] = { ...this.jsonData[idxChuvaAcumulada], dados: dadosChuva || [] };
  }

  /**
   * Adiciona ao jsonData séries para tipos visíveis em estacao_coletas que a API não retornou em tipos_variaveis
   * (ex.: chuva acumulada tipo 5 quando não há dados no período).
   */
  private adicionarSeriesVisiveisFaltantesJsonData(): void {
    if (!this.jsonData || !this.estacaoColetas.length) return;
    const idsPresentes = new Set((this.jsonData as any[]).map((v: any) => v.tipo_variavel && v.tipo_variavel.id));
    this.estacaoColetas.forEach((ec: any) => {
      const visible = this.isFlagTrue(ec.visualizar) || this.isFlagTrue(ec.visible);
      if (!visible || idsPresentes.has(ec.tipo_variavel_id)) return;
      const tipoVariavel = this.tipo_variavel.find((t: any) => t.value == ec.tipo_variavel_id);
      const label = tipoVariavel?.label || (ec.tipo_variavel_id === DashboardComponent.TIPO_VARIAVEL_CHUVA_ACUMULADA ? 'Chuva acumulada' : ec.tipo_variavel_id === DashboardComponent.TIPO_VARIAVEL_CHUVA ? 'Chuva' : `Variável ${ec.tipo_variavel_id}`);
      this.jsonData.push({
        tipo_variavel: { id: ec.tipo_variavel_id, tipo_variavel: label, tipo_grafico: 'line' },
        dados: []
      });
      idsPresentes.add(ec.tipo_variavel_id);
    });
  }

  /**
   */
  private getDataAtualBrasilia(): moment.Moment {
    // Obtém a data atual em UTC e ajusta para o fuso de Brasília (UTC-3)
    return moment().utcOffset(-180); // -180 minutos = UTC-3
  }

  /**
   * Retorna o limite final para geração de intervalos (tabela e gráfico).
   * - Se o último dia do filtro for anterior a hoje: considera até 23:59 do último dia.
   * - Se o último dia for hoje ou futuro: limita à data/hora atual (não pode ser futuro).
   */
  private getDataFinalLimitadaIntervalos(): moment.Moment {
    const dataAtualBrasilia = this.getDataAtualBrasilia();
    const dataFinal = moment(this.rangeDate[1]).utcOffset(-180);
    const ultimoDiaFiltro = dataFinal.clone().startOf('day');
    const hoje = dataAtualBrasilia.clone().startOf('day');
    if (ultimoDiaFiltro.isBefore(hoje)) {
      return dataFinal.clone().endOf('day');
    }
    return dataAtualBrasilia.clone();
  }

  /**
   * Preenche os intervalos na tabela: sempre inclui uma linha para cada horário alinhado ao intervalo
   * (ex: 5 min → 13:40, 13:45, 13:50). Quando existe dado da API no horário exato do intervalo, usa esse dado;
   * quando existe dado "sobrando" dentro do intervalo (ex: 13:42 no intervalo 13:40–13:45), insere linha extra
   * com a data/hora exata (13:42).
   *
   * A comparação é feita por MINUTO (ignorando segundos), então:
   * - Dado 13:40:30 → vai para o slot 13:40 (mesmo minuto do intervalo)
   * - Dado 13:42:30 → inserido como extra 13:42 (minuto diferente de qualquer intervalo)
   */
  private preencherIntervalosTabela(): void {
    if (!this.intervaloOperacao || this.intervaloOperacao <= 0 || !this.rangeDate || this.rangeDate.length < 2) {
      return;
    }

    const dataFinalLimitada = this.getDataFinalLimitadaIntervalos();

    const variaveisKeys = new Set<string>();
    this.dadosVariavel.forEach(dado => {
      Object.keys(dado).forEach(key => {
        if (key !== 'data' && key !== 'timestamp') variaveisKeys.add(key);
      });
    });
    if (variaveisKeys.size === 0 && this.columnsVariavel.length > 0) {
      this.columnsVariavel.forEach(col => {
        if (col.field !== 'data' && col.field !== 'timestamp') variaveisKeys.add(col.field);
      });
    }

    const dataInicial = moment(this.rangeDate[0]).utcOffset(-180);
    const minutosIniciais = dataInicial.minute();
    const minutosArredondados = Math.floor(minutosIniciais / this.intervaloOperacao) * this.intervaloOperacao;
    const dataInicialAlinhada = dataInicial.clone().minute(minutosArredondados).second(0).millisecond(0);

    // Função auxiliar para arredondar timestamp para o minuto (ignorar segundos/milissegundos)
    const arredondarParaMinuto = (ts: number): number => {
      const m = moment(ts).utcOffset(-180);
      return m.clone().second(0).millisecond(0).valueOf();
    };

    // Conjunto de timestamps alinhados ao intervalo (ex: 13:40:00, 13:45:00, 13:50:00)
    const intervalosAlinhados = new Set<number>();
    let dataAtual = dataInicialAlinhada.clone();
    while (dataAtual.isSameOrBefore(dataFinalLimitada)) {
      intervalosAlinhados.add(dataAtual.valueOf());
      dataAtual.add(this.intervaloOperacao, 'minutes');
    }

    // Dado da API por timestamp arredondado para o minuto
    // Isso permite que 13:40:30 seja mapeado para o slot 13:40:00
    const dadoPorMinuto = new Map<number, any>();
    this.dadosVariavel.forEach(dado => {
      const tsMinuto = arredondarParaMinuto(dado.timestamp);
      // Se já existe um dado para este minuto, mantém o primeiro (ou pode sobrescrever, dependendo da preferência)
      if (!dadoPorMinuto.has(tsMinuto)) {
        dadoPorMinuto.set(tsMinuto, dado);
      }
    });

    const resultado: any[] = [];
    const minutosUsados = new Set<number>(); // Para rastrear quais minutos já foram usados pelos intervalos

    // 1) Uma linha para cada intervalo alinhado: com dado se houver no mesmo minuto, senão vazia
    intervalosAlinhados.forEach(timestamp => {
      const dado = dadoPorMinuto.get(timestamp); // timestamp já está arredondado (segundo = 0)
      if (dado) {
        // Usa o dado, mas ajusta o timestamp de exibição para o intervalo alinhado
        resultado.push({
          ...dado,
          data: moment(timestamp).utcOffset(-180).format('DD/MM/YYYY HH:mm'),
          timestamp: timestamp
        });
        minutosUsados.add(timestamp);
      } else {
        const novoRegistro: any = {
          data: moment(timestamp).utcOffset(-180).format('DD/MM/YYYY HH:mm'),
          timestamp
        };
        variaveisKeys.forEach(key => { novoRegistro[key] = null; });
        resultado.push(novoRegistro);
      }
    });

    // 2) Linhas extras para dados "sobrando" (minuto não corresponde a nenhum intervalo, ex: 13:42)
    this.dadosVariavel.forEach(dado => {
      const tsMinuto = arredondarParaMinuto(dado.timestamp);
      // Se o minuto não corresponde a nenhum intervalo alinhado, é um dado "extra"
      if (!intervalosAlinhados.has(tsMinuto)) {
        // Mantém a data/hora exata do dado (sem arredondar)
        resultado.push({
          ...dado,
          data: moment(dado.timestamp).utcOffset(-180).format('DD/MM/YYYY HH:mm'),
          timestamp: arredondarParaMinuto(dado.timestamp) // Arredonda para o minuto para ordenação consistente
        });
      }
    });

    this.dadosVariavel = resultado.sort((a, b) => b.timestamp - a.timestamp);
  }

  /**
   * Preenche os intervalos nos gráficos: sempre inclui um ponto para cada horário alinhado ao intervalo.
   * Quando existe dado da API no horário exato do intervalo, usa esse dado; quando existe dado "sobrando"
   * (ex: 13:42 no intervalo 5 min), insere ponto extra com a data/hora exata (13:42).
   *
   * A comparação é feita por MINUTO (ignorando segundos), então:
   * - Dado 13:40:30 → vai para o slot 13:40 (mesmo minuto do intervalo)
   * - Dado 13:42:30 → inserido como extra 13:42 (minuto diferente de qualquer intervalo)
   */
  private preencherIntervalosGraficos(): void {
    if (!this.intervaloOperacao || this.intervaloOperacao <= 0 || !this.rangeDate || this.rangeDate.length < 2 || !this.jsonData) {
      return;
    }

    const dataFinalLimitada = this.getDataFinalLimitadaIntervalos();
    const dataInicial = moment(this.rangeDate[0]).utcOffset(-180);
    const minutosIniciais = dataInicial.minute();
    const minutosArredondados = Math.floor(minutosIniciais / this.intervaloOperacao) * this.intervaloOperacao;
    const dataInicialAlinhada = dataInicial.clone().minute(minutosArredondados).second(0).millisecond(0);

    // Função auxiliar para arredondar timestamp para o minuto (ignorar segundos/milissegundos)
    const arredondarParaMinuto = (ts: number): number => {
      const m = moment(ts).utcOffset(-180);
      return m.clone().second(0).millisecond(0).valueOf();
    };

    const intervalosAlinhados: number[] = [];
    let dataAtual = dataInicialAlinhada.clone();
    while (dataAtual.isSameOrBefore(dataFinalLimitada)) {
      intervalosAlinhados.push(dataAtual.valueOf());
      dataAtual.add(this.intervaloOperacao, 'minutes');
    }
    const setAlinhados = new Set(intervalosAlinhados);

    this.jsonData.forEach((variavel) => {
      if (!variavel.dados) variavel.dados = [];

      // Normaliza o dado e arredonda o timestamp para o minuto
      const normalizar = (d: any) => {
        const tsOriginal = d.timestamp || moment(d.data_hora_dado, 'DD/MM/YYYY HH:mm:ss').utcOffset(-180).valueOf();
        const tsMinuto = arredondarParaMinuto(tsOriginal);
        return {
          ...d,
          timestamp: tsMinuto,
          timestampOriginal: tsOriginal,
          data_hora_dado: moment(tsMinuto).utcOffset(-180).format('DD/MM/YYYY HH:mm:ss')
        };
      };

      // Mapa de timestamp arredondado para o minuto → dado normalizado
      const dadoPorMinuto = new Map<number, any>();
      variavel.dados.forEach((d: any) => {
        const norm = normalizar(d);
        // Se já existe um dado para este minuto, mantém o primeiro
        if (!dadoPorMinuto.has(norm.timestamp)) {
          dadoPorMinuto.set(norm.timestamp, norm);
        }
      });

      const resultado: any[] = [];

      // 1) Um ponto para cada intervalo alinhado: com dado se houver no mesmo minuto, senão null
      intervalosAlinhados.forEach(timestamp => {
        const dado = dadoPorMinuto.get(timestamp); // timestamp já está arredondado (segundo = 0)
        if (dado) {
          // Usa o dado, mas ajusta o timestamp/data_hora_dado para o intervalo alinhado
          resultado.push({
            ...dado,
            data_hora_dado: moment(timestamp).utcOffset(-180).format('DD/MM/YYYY HH:mm:ss'),
            timestamp: timestamp
          });
        } else {
          resultado.push({
            data_hora_dado: moment(timestamp).utcOffset(-180).format('DD/MM/YYYY HH:mm:ss'),
            timestamp,
            valor: null,
            valor_original: null
          });
        }
      });

      // 2) Pontos extras para dados "sobrando" (minuto não corresponde a nenhum intervalo)
      variavel.dados.forEach((d: any) => {
        const norm = normalizar(d);
        // Se o minuto não corresponde a nenhum intervalo alinhado, é um dado "extra"
        if (!setAlinhados.has(norm.timestamp)) {
          // Mantém a data/hora do minuto (sem segundos, para consistência)
          resultado.push({
            ...norm,
            data_hora_dado: moment(norm.timestamp).utcOffset(-180).format('DD/MM/YYYY HH:mm:ss'),
            timestamp: norm.timestamp
          });
        }
      });

      variavel.dados = resultado.sort((a, b) => a.timestamp - b.timestamp);
    });
  }

  /**
   * Arredonda um timestamp para o início do intervalo de operação (sempre para baixo)
   * Ex: se intervalo é 60 min e timestamp é 06:30:00, retorna 06:00:00
   * Trata o timestamp como horário de Brasília (UTC-3) para garantir consistência
   */
  private arredondarParaIntervalo(timestamp: number): number {
    if (!this.intervaloOperacao || this.intervaloOperacao <= 0) {
      return timestamp;
    }
    
    // Converte o timestamp para moment em horário de Brasília (UTC-3)
    const data = moment(timestamp).utcOffset(-180);
    const minutos = data.minute();
    // Sempre arredonda para baixo (Math.floor) para garantir consistência
    const minutosArredondados = Math.floor(minutos / this.intervaloOperacao) * this.intervaloOperacao;
    
    return data.clone().minute(minutosArredondados).second(0).millisecond(0).valueOf();
  }

  /**
   * Cria intervalos vazios quando não há dados, mas há intervalo_operacao configurado
   */
  private criarIntervalosVazios(jsonGroupData?: any): void {
    if (!this.intervaloOperacao || this.intervaloOperacao <= 0 || !this.rangeDate || this.rangeDate.length < 2) {
      return;
    }

    // Obtém as variáveis visíveis para criar as colunas
    const variaveisKeys = new Set<string>();
    
    // Primeiro tenta buscar das variáveis do json[0] (tipos_variaveis)
    if (jsonGroupData && jsonGroupData.length > 0 && jsonGroupData[0].tipos_variaveis) {
      jsonGroupData[0].tipos_variaveis.forEach((variavel: any) => {
        if (variavel.tipo_variavel && variavel.tipo_variavel.tipo_variavel) {
          const estacaoColetaVariavel = this.estacaoColetas.find(x => {
            return x.tipo_variavel_id == variavel.tipo_variavel.id;
          });
          
          // Verifica visibilidade (com regra especial para VAZÃO)
          if (this.isVariavelVisivel(variavel.tipo_variavel.id, estacaoColetaVariavel)) {
            variaveisKeys.add(variavel.tipo_variavel.tipo_variavel);
          }
        }
      });
    }
    
    // Se não encontrou, busca as variáveis visíveis de estacaoColetas usando tipo_variavel
    if (variaveisKeys.size === 0 && this.estacaoColetas && this.estacaoColetas.length > 0) {
      this.estacaoColetas.forEach(ec => {
        // Verifica visibilidade (com regra especial para VAZÃO)
        if (this.isVariavelVisivel(ec.tipo_variavel_id, ec)) {
          // Busca o nome da variável pelo tipo_variavel_id
          const tipoVariavel = this.tipo_variavel.find(tv => tv.value == ec.tipo_variavel_id);
          if (tipoVariavel && tipoVariavel.label) {
            variaveisKeys.add(tipoVariavel.label);
          }
        }
      });
    }

    // Se exibir_vazao for true, adiciona VAZÃO mesmo que não tenha estacaoColetaVariavel
    if (this.exibirVazao == true) {
      const tipoVariavelVazao = this.tipo_variavel.find(tv => tv.value == 4);
      if (tipoVariavelVazao && tipoVariavelVazao.label) {
        variaveisKeys.add(tipoVariavelVazao.label);
      }
    }

    // Gera todos os intervalos de tempo dentro do período
    // Converte para horário de Brasília (UTC-3) para garantir consistência
    const dataInicial = moment(this.rangeDate[0]).utcOffset(-180);
    const dataFinalLimitada = this.getDataFinalLimitadaIntervalos();
    
    // Alinha a data inicial ao intervalo mais próximo (para trás)
    const minutosIniciais = dataInicial.minute();
    const minutosArredondados = Math.floor(minutosIniciais / this.intervaloOperacao) * this.intervaloOperacao;
    const dataInicialAlinhada = dataInicial.clone().minute(minutosArredondados).second(0).millisecond(0);
    
    const intervalosGerados: any[] = [];
    let dataAtual = dataInicialAlinhada.clone();

    while (dataAtual.isSameOrBefore(dataFinalLimitada)) {
      const timestamp = dataAtual.valueOf();
      
      // Cria um registro vazio para este intervalo
      // Formata a data em horário de Brasília para manter consistência
      const novoRegistro: any = {
        data: moment(timestamp).utcOffset(-180).format('DD/MM/YYYY HH:mm'),
        timestamp: timestamp
      };
      
      // Adiciona todas as variáveis visíveis como null (sem valor, só horário)
      variaveisKeys.forEach(key => {
        novoRegistro[key] = null;
      });
      
      intervalosGerados.push(novoRegistro);

      // Avança para o próximo intervalo
      dataAtual.add(this.intervaloOperacao, 'minutes');
    }

    // Ordena por timestamp (descendente)
    this.dadosVariavel = intervalosGerados.sort((a, b) => b.timestamp - a.timestamp);
    
    // Define as colunas
    const allKeys = new Set<string>(['data', 'timestamp', ...Array.from(variaveisKeys)]);
    this.columnsVariavel = Array.from(allKeys).map(key => ({ field: key, header: key.toUpperCase() }));
  }

  /**
   * Cria intervalos vazios nos gráficos quando não há dados, mas há intervalo_operacao configurado.
   * Mesmo comportamento da tabela (criarIntervalosVazios): variáveis visíveis com um ponto por intervalo (valor null).
   */
  private criarIntervalosVaziosGrafico(jsonGroupData?: any): void {
    if (!this.intervaloOperacao || this.intervaloOperacao <= 0 || !this.rangeDate || this.rangeDate.length < 2) {
      return;
    }

    // Lista de variáveis visíveis: { id, tipo_variavel (nome), tipo_grafico }
    const variaveisParaGrafico: { id: number; tipo_variavel: string; tipo_grafico: string }[] = [];

    if (jsonGroupData && jsonGroupData.length > 0 && jsonGroupData[0].tipos_variaveis) {
      jsonGroupData[0].tipos_variaveis.forEach((variavel: any) => {
        if (variavel.tipo_variavel && variavel.tipo_variavel.tipo_variavel) {
          const estacaoColetaVariavel = this.estacaoColetas.find(x => x.tipo_variavel_id == variavel.tipo_variavel.id);
          if (this.isVariavelVisivel(variavel.tipo_variavel.id, estacaoColetaVariavel)) {
            variaveisParaGrafico.push({
              id: variavel.tipo_variavel.id,
              tipo_variavel: variavel.tipo_variavel.tipo_variavel,
              tipo_grafico: variavel.tipo_variavel.tipo_grafico || 'line'
            });
          }
        }
      });
    }

    if (variaveisParaGrafico.length === 0 && this.estacaoColetas && this.estacaoColetas.length > 0) {
      this.estacaoColetas.forEach(ec => {
        if (this.isVariavelVisivel(ec.tipo_variavel_id, ec)) {
          const tipoVariavel = this.tipo_variavel.find(tv => tv.value == ec.tipo_variavel_id);
          if (tipoVariavel && tipoVariavel.label) {
            variaveisParaGrafico.push({
              id: ec.tipo_variavel_id,
              tipo_variavel: tipoVariavel.label,
              tipo_grafico: 'line'
            });
          }
        }
      });
    }

    if (this.exibirVazao === true) {
      const tipoVariavelVazao = this.tipo_variavel.find(tv => tv.value == 4);
      if (tipoVariavelVazao && tipoVariavelVazao.label) {
        const jaTem = variaveisParaGrafico.some(v => v.id === 4);
        if (!jaTem) {
          variaveisParaGrafico.push({
            id: 4,
            tipo_variavel: tipoVariavelVazao.label,
            tipo_grafico: 'line'
          });
        }
      }
    }

    const dataInicial = moment(this.rangeDate[0]).utcOffset(-180);
    const dataFinalLimitada = this.getDataFinalLimitadaIntervalos();
    const minutosIniciais = dataInicial.minute();
    const minutosArredondados = Math.floor(minutosIniciais / this.intervaloOperacao) * this.intervaloOperacao;
    const dataInicialAlinhada = dataInicial.clone().minute(minutosArredondados).second(0).millisecond(0);

    const intervalosAlinhados: number[] = [];
    let dataAtual = dataInicialAlinhada.clone();
    while (dataAtual.isSameOrBefore(dataFinalLimitada)) {
      intervalosAlinhados.push(dataAtual.valueOf());
      dataAtual.add(this.intervaloOperacao, 'minutes');
    }

    this.jsonData = variaveisParaGrafico.map(v => ({
      tipo_variavel: {
        id: v.id,
        tipo_variavel: v.tipo_variavel,
        tipo_grafico: v.tipo_grafico
      },
      dados: intervalosAlinhados.map(timestamp => ({
        data_hora_dado: moment(timestamp).utcOffset(-180).format('DD/MM/YYYY HH:mm:ss'),
        timestamp,
        valor: null,
        valor_original: null
      })).sort((a, b) => a.timestamp - b.timestamp)
    }));
  }

}
